var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectmanagement1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2289.18 1426.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#91b3fa;}.cls-3{fill:#bdd0fb;}.cls-4{opacity:0.9;}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{opacity:0.88;}.cls-8{fill:#7d97f4;}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient-6);}.cls-12{fill:url(#linear-gradient-7);}.cls-13{fill:#18174a;}.cls-14{fill:#2b69b3;}.cls-15{fill:url(#linear-gradient-8);}.cls-16{fill:url(#linear-gradient-9);}.cls-17{fill:url(#linear-gradient-10);}.cls-18{fill:url(#linear-gradient-11);}.cls-19{fill:url(#linear-gradient-12);}.cls-20{fill:url(#linear-gradient-13);}.cls-21{fill:url(#linear-gradient-14);}.cls-22{fill:url(#linear-gradient-15);}.cls-23{fill:url(#linear-gradient-16);}.cls-24{fill:url(#linear-gradient-17);}.cls-25{fill:url(#linear-gradient-18);}.cls-26{fill:url(#linear-gradient-19);}.cls-27{fill:url(#linear-gradient-20);}.cls-28{fill:url(#linear-gradient-21);}.cls-29{fill:url(#linear-gradient-22);}.cls-30{fill:url(#linear-gradient-23);}.cls-31{fill:url(#linear-gradient-24);}.cls-32{fill:url(#linear-gradient-25);}.cls-33{fill:url(#linear-gradient-26);}.cls-34{fill:url(#linear-gradient-27);}.cls-35{fill:url(#linear-gradient-28);}.cls-36{fill:url(#linear-gradient-29);}.cls-37{fill:url(#linear-gradient-30);}.cls-38{fill:url(#linear-gradient-31);}.cls-39{fill:url(#linear-gradient-32);}.cls-40{fill:url(#linear-gradient-33);}.cls-41{fill:url(#linear-gradient-34);}.cls-42{fill:url(#linear-gradient-35);}.cls-43{fill:url(#linear-gradient-36);}.cls-44{fill:url(#linear-gradient-37);}.cls-45{fill:url(#linear-gradient-38);}.cls-46{fill:url(#linear-gradient-39);}.cls-47{fill:url(#linear-gradient-40);}.cls-48{fill:url(#linear-gradient-41);}.cls-49{fill:url(#linear-gradient-42);}.cls-50{fill:url(#linear-gradient-43);}.cls-51{fill:url(#linear-gradient-44);}.cls-52{fill:url(#linear-gradient-45);}.cls-53{fill:url(#linear-gradient-46);}.cls-54{fill:url(#linear-gradient-47);}.cls-55{fill:url(#linear-gradient-48);}.cls-56{fill:url(#linear-gradient-49);}.cls-57{fill:url(#linear-gradient-50);}.cls-58{fill:url(#linear-gradient-51);}.cls-59{fill:url(#linear-gradient-52);}.cls-60{fill:url(#linear-gradient-53);}.cls-61{fill:url(#linear-gradient-54);}.cls-62{fill:url(#linear-gradient-55);}.cls-63{fill:url(#linear-gradient-56);}.cls-64{fill:url(#linear-gradient-57);}.cls-65{fill:url(#linear-gradient-58);}.cls-66{fill:url(#linear-gradient-59);}.cls-67{fill:url(#linear-gradient-60);}.cls-68{fill:url(#linear-gradient-61);}.cls-69{fill:url(#linear-gradient-62);}.cls-70{fill:url(#linear-gradient-63);}.cls-71{fill:url(#linear-gradient-64);}.cls-72{fill:url(#linear-gradient-65);}.cls-73{fill:url(#linear-gradient-66);}.cls-74{fill:url(#linear-gradient-67);}.cls-75{fill:url(#linear-gradient-68);}.cls-76{fill:url(#linear-gradient-69);}.cls-77{fill:url(#linear-gradient-70);}.cls-78{fill:url(#linear-gradient-71);}.cls-79{fill:url(#linear-gradient-72);}.cls-80{fill:url(#linear-gradient-73);}.cls-81{fill:url(#linear-gradient-74);}.cls-82{fill:url(#linear-gradient-75);}.cls-83{fill:url(#linear-gradient-76);}.cls-84{fill:url(#linear-gradient-77);}.cls-85{fill:url(#linear-gradient-78);}.cls-86{fill:url(#linear-gradient-79);}.cls-87{fill:url(#linear-gradient-80);}.cls-88{fill:url(#linear-gradient-81);}.cls-89{fill:url(#linear-gradient-82);}.cls-90{fill:url(#linear-gradient-83);}.cls-91{fill:url(#linear-gradient-84);}.cls-92{fill:url(#linear-gradient-85);}.cls-93{fill:url(#linear-gradient-86);}.cls-94{fill:url(#linear-gradient-87);}.cls-95{fill:url(#linear-gradient-88);}.cls-96{fill:url(#linear-gradient-89);}.cls-97{fill:url(#linear-gradient-90);}.cls-98{fill:url(#linear-gradient-91);}.cls-99{fill:url(#linear-gradient-92);}.cls-100{fill:url(#linear-gradient-93);}.cls-101{fill:url(#linear-gradient-94);}.cls-102{fill:url(#linear-gradient-95);}.cls-103{fill:url(#linear-gradient-96);}.cls-104{fill:url(#linear-gradient-97);}.cls-105{fill:url(#linear-gradient-98);}.cls-106{fill:url(#linear-gradient-99);}.cls-107{fill:url(#linear-gradient-100);}.cls-108{fill:url(#linear-gradient-101);}.cls-109{fill:url(#linear-gradient-102);}.cls-110{fill:url(#linear-gradient-103);}.cls-111{fill:url(#linear-gradient-104);}.cls-112{fill:url(#linear-gradient-105);}.cls-113{fill:url(#linear-gradient-106);}.cls-114{fill:url(#linear-gradient-107);}.cls-115{fill:url(#linear-gradient-108);}.cls-116{fill:url(#linear-gradient-109);}.cls-117{fill:url(#linear-gradient-110);}.cls-118{fill:url(#linear-gradient-111);}.cls-119{fill:url(#linear-gradient-112);}.cls-120{fill:url(#linear-gradient-113);}.cls-121{fill:url(#linear-gradient-114);}.cls-122{fill:url(#linear-gradient-115);}.cls-123{fill:url(#linear-gradient-116);}.cls-124{fill:url(#linear-gradient-117);}.cls-125{fill:url(#linear-gradient-118);}.cls-126{fill:url(#linear-gradient-119);}.cls-127{fill:url(#linear-gradient-120);}.cls-128{fill:url(#linear-gradient-121);}.cls-129{fill:url(#linear-gradient-122);}.cls-130{fill:url(#linear-gradient-123);}.cls-131{fill:url(#linear-gradient-124);}.cls-132{fill:url(#linear-gradient-125);}.cls-133{fill:url(#linear-gradient-126);}.cls-134{fill:url(#linear-gradient-127);}.cls-135{fill:url(#linear-gradient-128);}.cls-136{fill:url(#linear-gradient-129);}.cls-137{fill:url(#linear-gradient-130);}.cls-138{fill:url(#linear-gradient-131);}.cls-139{fill:url(#linear-gradient-132);}.cls-140{fill:url(#linear-gradient-133);}.cls-141{fill:url(#linear-gradient-134);}.cls-142{fill:url(#linear-gradient-135);}.cls-143{fill:url(#linear-gradient-136);}.cls-144{fill:url(#linear-gradient-137);}.cls-145{fill:url(#linear-gradient-138);}.cls-146{fill:url(#linear-gradient-139);}.cls-147{fill:url(#linear-gradient-140);}.cls-148{fill:url(#linear-gradient-141);}.cls-149{fill:url(#linear-gradient-142);}.cls-150{fill:url(#linear-gradient-143);}.cls-151{fill:url(#linear-gradient-144);}.cls-152{fill:url(#linear-gradient-145);}.cls-153{fill:url(#linear-gradient-146);}.cls-154{fill:url(#linear-gradient-147);}.cls-155{fill:url(#linear-gradient-148);}.cls-156{fill:url(#linear-gradient-149);}.cls-157{fill:url(#linear-gradient-150);}.cls-158{fill:url(#linear-gradient-151);}.cls-159{fill:url(#linear-gradient-152);}.cls-160{fill:url(#linear-gradient-153);}.cls-161{fill:url(#linear-gradient-154);}.cls-162{fill:url(#linear-gradient-155);}.cls-163{fill:url(#linear-gradient-156);}.cls-164{fill:url(#linear-gradient-157);}.cls-165{fill:url(#linear-gradient-158);}.cls-166{fill:url(#linear-gradient-159);}.cls-167{fill:url(#linear-gradient-160);}.cls-168{fill:url(#linear-gradient-161);}.cls-169{fill:url(#linear-gradient-162);}.cls-170{fill:url(#linear-gradient-163);}.cls-171{fill:url(#linear-gradient-164);}.cls-172{fill:url(#linear-gradient-165);}.cls-173{fill:url(#linear-gradient-166);}.cls-174{fill:url(#linear-gradient-167);}.cls-175{fill:url(#linear-gradient-168);}.cls-176{fill:url(#linear-gradient-169);}.cls-177{fill:url(#linear-gradient-170);}.cls-178{fill:url(#linear-gradient-171);}.cls-179{fill:url(#linear-gradient-172);}.cls-180{fill:url(#linear-gradient-173);}.cls-181{fill:url(#linear-gradient-174);}.cls-182{fill:url(#linear-gradient-175);}.cls-183{fill:url(#linear-gradient-176);}.cls-184{fill:url(#linear-gradient-177);}.cls-185{fill:url(#linear-gradient-178);}.cls-186{fill:url(#linear-gradient-179);}.cls-187{fill:url(#linear-gradient-180);}.cls-188{fill:url(#linear-gradient-181);}.cls-189{fill:url(#linear-gradient-182);}.cls-190{fill:url(#linear-gradient-183);}.cls-191{fill:url(#linear-gradient-184);}.cls-192{fill:url(#linear-gradient-185);}.cls-193{fill:url(#linear-gradient-186);}.cls-194{fill:url(#linear-gradient-187);}.cls-195{fill:url(#linear-gradient-188);}.cls-196{fill:url(#linear-gradient-189);}.cls-197{fill:url(#linear-gradient-190);}.cls-198{fill:url(#linear-gradient-191);}.cls-199{fill:url(#linear-gradient-192);}.cls-200{fill:url(#linear-gradient-193);}.cls-201{fill:url(#linear-gradient-194);}.cls-202{fill:url(#linear-gradient-195);}.cls-203{fill:url(#linear-gradient-196);}.cls-204{fill:url(#linear-gradient-197);}.cls-205{fill:url(#linear-gradient-198);}.cls-206{fill:url(#linear-gradient-199);}.cls-207{fill:url(#linear-gradient-200);}.cls-208{fill:url(#linear-gradient-201);}.cls-209{fill:url(#linear-gradient-202);}.cls-210{fill:url(#linear-gradient-203);}.cls-211{fill:url(#linear-gradient-204);}.cls-212{fill:url(#linear-gradient-205);}.cls-213{fill:url(#linear-gradient-206);}.cls-214{fill:url(#linear-gradient-207);}.cls-215{fill:url(#linear-gradient-208);}.cls-216{fill:url(#linear-gradient-209);}.cls-217{fill:url(#linear-gradient-210);}.cls-218{fill:url(#linear-gradient-211);}.cls-219{fill:url(#linear-gradient-212);}.cls-220{fill:url(#linear-gradient-213);}.cls-221{fill:url(#linear-gradient-214);}.cls-222{fill:url(#linear-gradient-215);}.cls-223{fill:url(#linear-gradient-216);}.cls-224{fill:url(#linear-gradient-217);}.cls-225{fill:url(#linear-gradient-218);}.cls-226{fill:url(#linear-gradient-219);}.cls-227{fill:url(#linear-gradient-220);}.cls-228{fill:url(#linear-gradient-221);}.cls-229{fill:url(#linear-gradient-222);}.cls-230,.cls-313{fill:#fff;}.cls-231{fill:url(#linear-gradient-223);}.cls-232{fill:url(#linear-gradient-224);}.cls-233{fill:url(#linear-gradient-225);}.cls-234{fill:url(#linear-gradient-226);}.cls-235{fill:url(#linear-gradient-227);}.cls-236{fill:url(#linear-gradient-228);}.cls-237{fill:url(#linear-gradient-229);}.cls-238{fill:url(#linear-gradient-230);}.cls-239{fill:url(#linear-gradient-231);}.cls-240{fill:url(#linear-gradient-232);}.cls-241{fill:url(#linear-gradient-233);}.cls-242{fill:url(#linear-gradient-234);}.cls-243{fill:url(#linear-gradient-235);}.cls-244{fill:url(#linear-gradient-236);}.cls-245{fill:url(#linear-gradient-237);}.cls-246{fill:url(#linear-gradient-238);}.cls-247{fill:url(#linear-gradient-239);}.cls-248{fill:url(#linear-gradient-240);}.cls-249{fill:url(#linear-gradient-241);}.cls-250{fill:url(#linear-gradient-242);}.cls-251{fill:url(#linear-gradient-243);}.cls-252{fill:url(#linear-gradient-244);}.cls-253{fill:url(#linear-gradient-245);}.cls-254{fill:url(#linear-gradient-246);}.cls-255{fill:url(#linear-gradient-247);}.cls-256{fill:url(#linear-gradient-248);}.cls-257{fill:url(#linear-gradient-249);}.cls-258{fill:url(#linear-gradient-250);}.cls-259{fill:url(#linear-gradient-251);}.cls-260{fill:url(#linear-gradient-252);}.cls-261{fill:url(#linear-gradient-253);}.cls-262{fill:url(#linear-gradient-254);}.cls-263{fill:url(#linear-gradient-255);}.cls-264{fill:url(#linear-gradient-256);}.cls-265{fill:url(#linear-gradient-257);}.cls-266{fill:url(#linear-gradient-258);}.cls-267{fill:url(#linear-gradient-259);}.cls-268{fill:url(#linear-gradient-260);}.cls-269{fill:url(#linear-gradient-261);}.cls-270,.cls-313{isolation:isolate;}.cls-270{opacity:0.34;fill:url(#linear-gradient-262);}.cls-271{fill:url(#linear-gradient-263);}.cls-272{fill:url(#linear-gradient-264);}.cls-273{fill:url(#linear-gradient-265);}.cls-274{fill:url(#linear-gradient-266);}.cls-275{fill:url(#linear-gradient-267);}.cls-276{fill:url(#linear-gradient-268);}.cls-277{fill:url(#linear-gradient-269);}.cls-278{fill:url(#linear-gradient-270);}.cls-279{fill:url(#linear-gradient-271);}.cls-280{fill:url(#linear-gradient-272);}.cls-281{fill:url(#linear-gradient-273);}.cls-282{fill:url(#linear-gradient-274);}.cls-283{fill:url(#linear-gradient-275);}.cls-284{fill:url(#linear-gradient-276);}.cls-285{fill:url(#linear-gradient-277);}.cls-286{fill:url(#linear-gradient-278);}.cls-287{fill:url(#linear-gradient-279);}.cls-288{fill:url(#linear-gradient-280);}.cls-289{fill:url(#linear-gradient-281);}.cls-290{fill:url(#linear-gradient-282);}.cls-291{fill:url(#linear-gradient-283);}.cls-292{fill:url(#linear-gradient-284);}.cls-293{fill:url(#linear-gradient-285);}.cls-294{fill:url(#linear-gradient-286);}.cls-295{fill:url(#linear-gradient-287);}.cls-296{fill:url(#linear-gradient-288);}.cls-297{fill:url(#linear-gradient-289);}.cls-298{fill:url(#linear-gradient-290);}.cls-299{fill:url(#linear-gradient-291);}.cls-300{fill:url(#linear-gradient-292);}.cls-301{fill:url(#linear-gradient-293);}.cls-302{fill:url(#linear-gradient-294);}.cls-303{fill:url(#linear-gradient-295);}.cls-304{fill:url(#linear-gradient-296);}.cls-305{fill:url(#linear-gradient-297);}.cls-306{fill:url(#linear-gradient-298);}.cls-307{fill:url(#linear-gradient-299);}.cls-308{fill:url(#linear-gradient-300);}.cls-309{fill:url(#linear-gradient-301);}.cls-310{fill:url(#linear-gradient-302);}.cls-311{fill:url(#linear-gradient-303);}.cls-312{fill:url(#linear-gradient-304);}.cls-313{opacity:0.2;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 49.67,
    y1: 774.72,
    x2: 2021.12,
    y2: 774.72,
    gradientTransform: "matrix(1.11, -0.07, -0.07, -1.02, 34.75, 1509.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 290.52,
    y1: 913.93,
    x2: 632.13,
    y2: 913.93,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1955.05,
    y1: 897.67,
    x2: 2246.54,
    y2: 897.67,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 170.51,
    y1: 448.2,
    x2: 427.81,
    y2: 448.2,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 173.92,
    y1: 420.11,
    x2: 400.5,
    y2: 420.11,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 115.04,
    y1: 275.93,
    x2: 447.09,
    y2: 275.93,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 121.97,
    y1: 355,
    x2: 443.38,
    y2: 355,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1506.41,
    y1: 1188.44,
    x2: 1369.59,
    y2: 1001.05,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -3845.51,
    y1: 743.51,
    x2: -3884.61,
    y2: 623.66,
    gradientTransform: "translate(-2666.94 1475.4) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -3853.79,
    y1: 317.65,
    x2: -3771.4,
    y2: 317.65,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -1851.3,
    y1: 859.24,
    x2: -1671.3,
    y2: 917.24,
    gradientTransform: "translate(-2666.94 1475.4) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -1854.52,
    y1: 869.22,
    x2: -1674.52,
    y2: 927.22,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -3903.78,
    y1: 311.47,
    x2: -3856.07,
    y2: 311.47,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -4006.59,
    y1: 669.41,
    x2: -3913.16,
    y2: 669.41,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -3840.81,
    y1: 493.14,
    x2: -3665.71,
    y2: 146.34,
    gradientTransform: "translate(-2666.94 1475.4) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -3889.32,
    y1: 623.57,
    x2: -3860.13,
    y2: 623.57,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -3842.91,
    y1: 661.36,
    x2: -3630.41,
    y2: 646.91,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1496.97,
    y1: 665.29,
    x2: 1499.85,
    y2: 665.29,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1491.46,
    y1: 658.23,
    x2: 1494.45,
    y2: 658.23,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1485.73,
    y1: 651.39,
    x2: 1488.82,
    y2: 651.39,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1479.78,
    y1: 644.6,
    x2: 1482.97,
    y2: 644.6,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1473.62,
    y1: 638.13,
    x2: 1476.91,
    y2: 638.13,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1467.26,
    y1: 631.69,
    x2: 1470.64,
    y2: 631.69,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1460.7,
    y1: 625.64,
    x2: 1464.18,
    y2: 625.64,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1453.96,
    y1: 619.73,
    x2: 1457.53,
    y2: 619.73,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1447.04,
    y1: 614.04,
    x2: 1450.7,
    y2: 614.04,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1439.94,
    y1: 608.54,
    x2: 1443.7,
    y2: 608.54,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1432.68,
    y1: 603.29,
    x2: 1436.52,
    y2: 603.29,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1425.26,
    y1: 598.26,
    x2: 1429.19,
    y2: 598.26,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1417.69,
    y1: 593.45,
    x2: 1421.7,
    y2: 593.45,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1409.98,
    y1: 588.85,
    x2: 1414.07,
    y2: 588.85,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1402.13,
    y1: 584.54,
    x2: 1406.29,
    y2: 584.54,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1394.15,
    y1: 580.46,
    x2: 1398.39,
    y2: 580.46,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1386.05,
    y1: 576.59,
    x2: 1390.36,
    y2: 576.59,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1377.83,
    y1: 573.06,
    x2: 1382.21,
    y2: 573.06,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1369.51,
    y1: 569.59,
    x2: 1373.96,
    y2: 569.59,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1361.08,
    y1: 566.63,
    x2: 1365.6,
    y2: 566.63,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1352.56,
    y1: 563.84,
    x2: 1357.15,
    y2: 563.84,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1343.96,
    y1: 561.32,
    x2: 1348.61,
    y2: 561.32,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1335.28,
    y1: 559.07,
    x2: 1339.99,
    y2: 559.07,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1326.54,
    y1: 557.13,
    x2: 1331.3,
    y2: 557.13,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1317.74,
    y1: 555.47,
    x2: 1322.55,
    y2: 555.47,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1308.89,
    y1: 554.06,
    x2: 1313.76,
    y2: 554.06,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1300.01,
    y1: 552.94,
    x2: 1304.91,
    y2: 552.94,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1291.11,
    y1: 552.11,
    x2: 1296.03,
    y2: 552.11,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1282.18,
    y1: 551.55,
    x2: 1287.13,
    y2: 551.55,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1273.24,
    y1: 551.25,
    x2: 1278.21,
    y2: 551.25,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1264.29,
    y1: 551.25,
    x2: 1269.29,
    y2: 551.25,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1255.35,
    y1: 551.54,
    x2: 1260.37,
    y2: 551.54,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1246.42,
    y1: 552.09,
    x2: 1251.46,
    y2: 552.09,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1237.52,
    y1: 552.91,
    x2: 1242.57,
    y2: 552.91,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1228.64,
    y1: 554,
    x2: 1233.71,
    y2: 554,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 1219.81,
    y1: 555.37,
    x2: 1224.89,
    y2: 555.37,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1211.03,
    y1: 557.05,
    x2: 1216.11,
    y2: 557.05,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 1202.3,
    y1: 558.94,
    x2: 1207.38,
    y2: 558.94,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1193.64,
    y1: 561.12,
    x2: 1198.72,
    y2: 561.12,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1185.05,
    y1: 563.58,
    x2: 1190.14,
    y2: 563.58,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1176.55,
    y1: 566.36,
    x2: 1181.63,
    y2: 566.36,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1168.14,
    y1: 569.34,
    x2: 1173.21,
    y2: 569.34,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1159.83,
    y1: 572.57,
    x2: 1164.9,
    y2: 572.57,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1151.63,
    y1: 576.16,
    x2: 1156.69,
    y2: 576.16,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 1143.56,
    y1: 579.95,
    x2: 1148.6,
    y2: 579.95,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1135.61,
    y1: 584,
    x2: 1140.63,
    y2: 584,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 1127.8,
    y1: 588.33,
    x2: 1132.8,
    y2: 588.33,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1120.13,
    y1: 592.94,
    x2: 1125.11,
    y2: 592.94,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1112.62,
    y1: 597.75,
    x2: 1117.58,
    y2: 597.75,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1105.28,
    y1: 602.83,
    x2: 1110.21,
    y2: 602.83,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 1098.11,
    y1: 608.09,
    x2: 1103,
    y2: 608.09,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 1091.12,
    y1: 613.66,
    x2: 1095.98,
    y2: 613.66,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 1084.32,
    y1: 619.39,
    x2: 1089.15,
    y2: 619.39,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 1077.73,
    y1: 625.45,
    x2: 1082.51,
    y2: 625.45,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 1071.34,
    y1: 631.67,
    x2: 1076.09,
    y2: 631.67,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 1065.19,
    y1: 638.17,
    x2: 1069.88,
    y2: 638.17,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 1059.27,
    y1: 644.75,
    x2: 1063.91,
    y2: 644.75,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 1053.59,
    y1: 651.68,
    x2: 1058.19,
    y2: 651.68,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 1048.17,
    y1: 658.77,
    x2: 1052.71,
    y2: 658.77,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 1043.02,
    y1: 666.08,
    x2: 1047.49,
    y2: 666.08,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 1038.14,
    y1: 673.44,
    x2: 1042.55,
    y2: 673.44,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 1033.55,
    y1: 681.1,
    x2: 1037.9,
    y2: 681.1,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 1029.27,
    y1: 688.96,
    x2: 1033.55,
    y2: 688.96,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 1025.29,
    y1: 696.92,
    x2: 1029.5,
    y2: 696.92,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 1021.6,
    y1: 705.04,
    x2: 1025.74,
    y2: 705.04,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 1018.23,
    y1: 713.25,
    x2: 1022.3,
    y2: 713.25,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 1015.16,
    y1: 721.56,
    x2: 1019.16,
    y2: 721.56,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 1012.39,
    y1: 730.14,
    x2: 1016.32,
    y2: 730.14,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 1009.93,
    y1: 738.96,
    x2: 1013.79,
    y2: 738.96,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 1007.78,
    y1: 747.34,
    x2: 1011.57,
    y2: 747.34,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 1005.94,
    y1: 756.1,
    x2: 1009.65,
    y2: 756.1,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 1004.4,
    y1: 764.89,
    x2: 1008.05,
    y2: 764.89,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 1003.18,
    y1: 773.78,
    x2: 1006.75,
    y2: 773.78,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 1002.26,
    y1: 782.61,
    x2: 1005.76,
    y2: 782.61,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 1001.65,
    y1: 791.49,
    x2: 1005.09,
    y2: 791.49,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 1001.36,
    y1: 800.46,
    x2: 1004.72,
    y2: 800.46,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 1001.34,
    y1: 809.49,
    x2: 1004.71,
    y2: 809.49,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 1001.57,
    y1: 818.33,
    x2: 1005.06,
    y2: 818.33,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 1002.12,
    y1: 827.24,
    x2: 1005.73,
    y2: 827.24,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 1002.98,
    y1: 836.13,
    x2: 1006.71,
    y2: 836.13,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 1004.16,
    y1: 844.97,
    x2: 1008,
    y2: 844.97,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 1005.66,
    y1: 853.77,
    x2: 1009.62,
    y2: 853.77,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 1007.47,
    y1: 862.51,
    x2: 1011.55,
    y2: 862.51,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 1009.59,
    y1: 871.11,
    x2: 1013.79,
    y2: 871.11,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 1012.04,
    y1: 879.82,
    x2: 1016.36,
    y2: 879.82,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 1014.8,
    y1: 888.2,
    x2: 1019.24,
    y2: 888.2,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 1017.88,
    y1: 896.58,
    x2: 1022.43,
    y2: 896.58,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 1021.26,
    y1: 904.84,
    x2: 1025.92,
    y2: 904.84,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 1024.94,
    y1: 912.94,
    x2: 1029.71,
    y2: 912.94,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 1028.9,
    y1: 920.95,
    x2: 1033.78,
    y2: 920.95,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 1033.15,
    y1: 928.8,
    x2: 1038.13,
    y2: 928.8,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 1037.66,
    y1: 936.41,
    x2: 1042.75,
    y2: 936.41,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 1042.44,
    y1: 943.92,
    x2: 1047.63,
    y2: 943.92,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 1047.48,
    y1: 951.32,
    x2: 1052.76,
    y2: 951.32,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 1052.76,
    y1: 958.42,
    x2: 1058.14,
    y2: 958.42,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 1058.28,
    y1: 965.43,
    x2: 1063.76,
    y2: 965.43,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 1064.04,
    y1: 972.18,
    x2: 1069.6,
    y2: 972.18,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 1070.02,
    y1: 978.76,
    x2: 1075.67,
    y2: 978.76,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 1076.23,
    y1: 985.17,
    x2: 1081.95,
    y2: 985.17,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 1082.65,
    y1: 991.31,
    x2: 1088.44,
    y2: 991.31,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 1089.27,
    y1: 997.31,
    x2: 1095.13,
    y2: 997.31,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 1096.09,
    y1: 1003.05,
    x2: 1102.02,
    y2: 1003.05,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 1103.1,
    y1: 1008.54,
    x2: 1109.09,
    y2: 1008.54,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 1110.28,
    y1: 1013.79,
    x2: 1116.33,
    y2: 1013.79,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 1117.65,
    y1: 1018.84,
    x2: 1123.75,
    y2: 1018.84,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 1125.17,
    y1: 1023.59,
    x2: 1131.34,
    y2: 1023.59,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 1132.86,
    y1: 1028.1,
    x2: 1139.08,
    y2: 1028.1,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 1140.7,
    y1: 1032.37,
    x2: 1146.97,
    y2: 1032.37,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 1148.68,
    y1: 1036.32,
    x2: 1155,
    y2: 1036.32,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 1156.79,
    y1: 1040.01,
    x2: 1163.16,
    y2: 1040.01,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 1165.04,
    y1: 1043.38,
    x2: 1171.45,
    y2: 1043.38,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 1173.39,
    y1: 1046.57,
    x2: 1179.84,
    y2: 1046.57,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 1181.85,
    y1: 1049.11,
    x2: 1188.33,
    y2: 1049.11,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 1190.4,
    y1: 1051.8,
    x2: 1196.92,
    y2: 1051.8,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 1199.04,
    y1: 1054.03,
    x2: 1205.58,
    y2: 1054.03,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 1207.74,
    y1: 1055.97,
    x2: 1214.31,
    y2: 1055.97,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 1216.5,
    y1: 1057.62,
    x2: 1223.1,
    y2: 1057.62,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 1225.32,
    y1: 1058.98,
    x2: 1231.93,
    y2: 1058.98,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 1234.18,
    y1: 1060.09,
    x2: 1240.81,
    y2: 1060.09,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 1243.06,
    y1: 1060.85,
    x2: 1249.71,
    y2: 1060.85,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 1251.97,
    y1: 1061.31,
    x2: 1258.63,
    y2: 1061.31,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 1260.89,
    y1: 1061.51,
    x2: 1267.56,
    y2: 1061.51,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 1269.82,
    y1: 1061.46,
    x2: 1276.5,
    y2: 1061.46,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 1278.75,
    y1: 1061.1,
    x2: 1285.43,
    y2: 1061.1,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 1287.66,
    y1: 1060.46,
    x2: 1294.34,
    y2: 1060.46,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 1296.54,
    y1: 1059.54,
    x2: 1303.22,
    y2: 1059.54,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 1305.4,
    y1: 1058.33,
    x2: 1312.08,
    y2: 1058.33,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 1314.22,
    y1: 1056.87,
    x2: 1320.88,
    y2: 1056.87,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 1322.98,
    y1: 1055.11,
    x2: 1329.64,
    y2: 1055.11,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 1331.69,
    y1: 1053.08,
    x2: 1338.33,
    y2: 1053.08,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 1340.32,
    y1: 1050.75,
    x2: 1346.95,
    y2: 1050.75,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 1348.88,
    y1: 1048.16,
    x2: 1355.49,
    y2: 1048.16,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 1357.35,
    y1: 1045.34,
    x2: 1363.94,
    y2: 1045.34,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 1365.72,
    y1: 1042.16,
    x2: 1372.29,
    y2: 1042.16,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 1373.99,
    y1: 1038.73,
    x2: 1380.53,
    y2: 1038.73,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 1382.14,
    y1: 1035.05,
    x2: 1388.65,
    y2: 1035.05,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 1390.18,
    y1: 1031.12,
    x2: 1396.67,
    y2: 1031.12,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 1398.12,
    y1: 1026.99,
    x2: 1404.57,
    y2: 1026.99,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 1405.96,
    y1: 1022.69,
    x2: 1412.4,
    y2: 1022.69,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 1413.72,
    y1: 1018.25,
    x2: 1420.15,
    y2: 1018.25,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 1421.43,
    y1: 1013.74,
    x2: 1427.84,
    y2: 1013.74,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 1429.09,
    y1: 1009.17,
    x2: 1435.5,
    y2: 1009.17,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 1436.73,
    y1: 1004.53,
    x2: 1443.14,
    y2: 1004.53,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 1444.36,
    y1: 999.88,
    x2: 1450.79,
    y2: 999.88,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 1452,
    y1: 995.27,
    x2: 1458.44,
    y2: 995.27,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 1459.68,
    y1: 990.75,
    x2: 1466.14,
    y2: 990.75,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 1467.41,
    y1: 986.25,
    x2: 1473.9,
    y2: 986.25,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 1475.2,
    y1: 981.93,
    x2: 1481.72,
    y2: 981.93,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 1483.08,
    y1: 977.75,
    x2: 1489.65,
    y2: 977.75,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 1491.05,
    y1: 973.71,
    x2: 1497.65,
    y2: 973.71,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 1499.14,
    y1: 970.01,
    x2: 1505.78,
    y2: 970.01,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 1507.34,
    y1: 966.54,
    x2: 1514.03,
    y2: 966.54,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 1515.66,
    y1: 963.36,
    x2: 1522.41,
    y2: 963.36,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 1524.12,
    y1: 960.58,
    x2: 1530.9,
    y2: 960.58,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 1532.69,
    y1: 958.13,
    x2: 1539.52,
    y2: 958.13,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 1541.37,
    y1: 956.1,
    x2: 1548.24,
    y2: 956.1,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 1550.15,
    y1: 954.53,
    x2: 1557.05,
    y2: 954.53,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 1559,
    y1: 953.48,
    x2: 1565.93,
    y2: 953.48,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 1567.91,
    y1: 952.85,
    x2: 1574.86,
    y2: 952.85,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 1576.83,
    y1: 952.77,
    x2: 1583.79,
    y2: 952.77,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 1585.75,
    y1: 953.25,
    x2: 1592.71,
    y2: 953.25,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 1594.63,
    y1: 954.3,
    x2: 1601.57,
    y2: 954.3,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 1603.41,
    y1: 955.9,
    x2: 1610.33,
    y2: 955.9,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 1612.07,
    y1: 958.25,
    x2: 1618.95,
    y2: 958.25,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 1620.54,
    y1: 961.15,
    x2: 1627.36,
    y2: 961.15,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 1628.76,
    y1: 964.7,
    x2: 1635.5,
    y2: 964.7,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 1636.68,
    y1: 968.93,
    x2: 1643.32,
    y2: 968.93,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 1644.23,
    y1: 973.79,
    x2: 1650.76,
    y2: 973.79,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 1651.37,
    y1: 979.22,
    x2: 1657.77,
    y2: 979.22,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 1658.04,
    y1: 985.42,
    x2: 1664.29,
    y2: 985.42,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 1664.17,
    y1: 991.75,
    x2: 1670.26,
    y2: 991.75,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 1669.7,
    y1: 998.89,
    x2: 1675.58,
    y2: 998.89,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 1674.53,
    y1: 1006.48,
    x2: 1680.2,
    y2: 1006.48,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 1678.59,
    y1: 1014.53,
    x2: 1684.02,
    y2: 1014.53,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 1681.81,
    y1: 1022.91,
    x2: 1686.97,
    y2: 1022.91,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 1684.08,
    y1: 1031.72,
    x2: 1688.94,
    y2: 1031.72,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 1685.37,
    y1: 1040.38,
    x2: 1689.92,
    y2: 1040.38,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 1685.56,
    y1: 1049.41,
    x2: 1690.03,
    y2: 1049.41,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 1684.61,
    y1: 1058.31,
    x2: 1689.37,
    y2: 1058.31,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 1682.7,
    y1: 1066.95,
    x2: 1687.74,
    y2: 1066.95,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 1679.82,
    y1: 1075.52,
    x2: 1685.16,
    y2: 1075.52,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 1675.99,
    y1: 1083.63,
    x2: 1681.62,
    y2: 1083.63,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 1671.2,
    y1: 1091.25,
    x2: 1677.12,
    y2: 1091.25,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 1665.48,
    y1: 1098.16,
    x2: 1671.68,
    y2: 1098.16,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 1658.87,
    y1: 1104.37,
    x2: 1665.34,
    y2: 1104.37,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 1651.46,
    y1: 1109.5,
    x2: 1658.16,
    y2: 1109.5,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 1643.39,
    y1: 1113.49,
    x2: 1650.26,
    y2: 1113.49,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 1634.87,
    y1: 1116.31,
    x2: 1641.85,
    y2: 1116.31,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 1626.07,
    y1: 1117.98,
    x2: 1633.12,
    y2: 1117.98,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 1617.15,
    y1: 1118.51,
    x2: 1624.21,
    y2: 1118.51,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 1608.27,
    y1: 1117.8,
    x2: 1615.29,
    y2: 1117.8,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 1599.59,
    y1: 1115.89,
    x2: 1606.53,
    y2: 1115.89,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 1591.32,
    y1: 1112.77,
    x2: 1598.11,
    y2: 1112.77,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 1583.68,
    y1: 1108.29,
    x2: 1590.25,
    y2: 1108.29,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 1576.93,
    y1: 1102.6,
    x2: 1583.19,
    y2: 1102.6,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 1571.36,
    y1: 1095.92,
    x2: 1577.21,
    y2: 1095.92,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 1567.2,
    y1: 1088.11,
    x2: 1572.59,
    y2: 1088.11,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 1564.49,
    y1: 1079.63,
    x2: 1569.42,
    y2: 1079.63,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 1563.19,
    y1: 1070.86,
    x2: 1567.68,
    y2: 1070.86,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 1563.1,
    y1: 1061.97,
    x2: 1567.5,
    y2: 1061.97,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 1564.12,
    y1: 1053.19,
    x2: 1568.93,
    y2: 1053.19,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 1566.5,
    y1: 1044.64,
    x2: 1571.74,
    y2: 1044.64,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 1570.27,
    y1: 1036.62,
    x2: 1575.95,
    y2: 1036.62,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 1575.44,
    y1: 1029.54,
    x2: 1581.54,
    y2: 1029.54,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 1581.94,
    y1: 1023.6,
    x2: 1588.43,
    y2: 1023.6,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 684.81,
    y1: 540.12,
    x2: 913.7,
    y2: 540.12,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 665.77,
    y1: 620.07,
    x2: 726.67,
    y2: 620.07,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.41)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 444.79,
    y1: 961.92,
    x2: 448.77,
    y2: 961.92,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 445.15,
    y1: 1073.88,
    x2: 742.67,
    y2: 1073.88,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 757.11,
    y1: 1104.68,
    x2: 765.58,
    y2: 1104.68,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 813.41,
    y1: 971.27,
    x2: 817.04,
    y2: 971.27,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 511.84,
    y1: 867.39,
    x2: 814.6,
    y2: 867.39,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 490.29,
    y1: 850.32,
    x2: 498.49,
    y2: 850.32,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 586.07,
    y1: 822.64,
    x2: 739.09,
    y2: 1341.69,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 995.85,
    y1: 1371.33,
    x2: 818.83,
    y2: 1179.31,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 995.98,
    y1: 1371.21,
    x2: 818.96,
    y2: 1179.19,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 864.93,
    y1: 1129.68,
    x2: 786.93,
    y2: 817.65,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 936.74,
    y1: 1111.73,
    x2: 858.73,
    y2: 799.7,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 986.21,
    y1: 1099.37,
    x2: 908.2,
    y2: 787.34,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: 943.31,
    y1: 1110.09,
    x2: 865.3,
    y2: 798.06,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 874.36,
    y1: 1127.33,
    x2: 796.36,
    y2: 815.3,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 829.34,
    y1: 1138.59,
    x2: 751.33,
    y2: 826.56,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: 1028.57,
    y1: 1051.49,
    x2: 1031.6,
    y2: 1051.49,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: 827.21,
    y1: 973.28,
    x2: 1031.23,
    y2: 973.28,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: 809.78,
    y1: 952.3,
    x2: 816.22,
    y2: 952.3,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: 773.99,
    y1: 1044.84,
    x2: 776.74,
    y2: 1044.84,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: 775.93,
    y1: 1117.59,
    x2: 983.5,
    y2: 1117.59,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: 993.69,
    y1: 1128.95,
    x2: 999.95,
    y2: 1128.95,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: 1112.8,
    y1: 1437,
    x2: 764.67,
    y2: 782.39,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: 1205.4,
    y1: 1381.35,
    x2: 1007.38,
    y2: 1159.33,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: 1205.33,
    y1: 1381.43,
    x2: 1007.31,
    y2: 1159.41,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: 1740.45,
    y1: -37.11,
    x2: 1761.78,
    y2: 85.55,
    gradientTransform: "matrix(1, 0, 0, -1, -411.02, 1475.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: 1728.73,
    y1: 62.3,
    x2: 1781.72,
    y2: 62.3,
    gradientTransform: "matrix(1, 0, 0, -1, -411.02, 1475.4)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: 1733.77,
    y1: 77.22,
    x2: 1749.13,
    y2: 77.22,
    gradientTransform: "matrix(1, 0, 0, -1, -411.02, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: 1618.3,
    y1: -15.87,
    x2: 1639.64,
    y2: 106.8,
    xlinkHref: "#linear-gradient-249"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: 1620.15,
    y1: 68.9,
    x2: 1650.83,
    y2: 68.9,
    gradientTransform: "matrix(1, 0, 0, -1, -411.02, 1475.4)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: 1636.13,
    y1: 90.02,
    x2: 1654.48,
    y2: 90.02,
    gradientTransform: "matrix(1, 0, 0, -1, -411.02, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: 1556.76,
    y1: 221.41,
    x2: 1379.43,
    y2: 83.41,
    gradientTransform: "matrix(1, 0, 0, -1, -411.02, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: 1517.34,
    y1: 410.06,
    x2: 1403.35,
    y2: 314.06,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-249"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    x1: 1720.22,
    y1: 357.57,
    x2: 1654.88,
    y2: 299.71,
    gradientTransform: "matrix(1, 0, 0, -1, -411.02, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    x1: 1524.83,
    y1: 262.45,
    x2: 1347.49,
    y2: 124.45,
    gradientTransform: "matrix(1, 0, 0, -1, -411.02, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-259",
    x1: 1583.95,
    y1: 186.48,
    x2: 1406.61,
    y2: 48.48,
    gradientTransform: "matrix(1, 0, 0, -1, -411.02, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-260",
    x1: 1842.71,
    y1: 352.1,
    x2: 1894.17,
    y2: 352.1,
    gradientTransform: "matrix(1, 0, 0, -1, -411.02, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-261",
    x1: 1792.69,
    y1: 489.61,
    x2: 1792.13,
    y2: 393.52,
    gradientTransform: "matrix(1, 0, 0, -1, -411.02, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-262",
    x1: 1493.28,
    y1: 433.89,
    x2: 1740.62,
    y2: 433.89,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-263",
    x1: 1494.59,
    y1: -1246.14,
    x2: 1447.28,
    y2: -1308.72,
    gradientTransform: "matrix(0.99, -0.14, -0.14, -0.99, -244.43, -49.89)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-264",
    x1: 1425.33,
    y1: -1295.7,
    x2: 1463.27,
    y2: -1256.77,
    gradientTransform: "matrix(0.99, -0.14, -0.14, -0.99, -244.43, -49.89)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-265",
    x1: 1746.02,
    y1: 328.43,
    x2: 1680.68,
    y2: 270.57,
    gradientTransform: "matrix(1, 0, 0, -1, -411.02, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-266",
    x1: 1511.49,
    y1: 477.65,
    x2: 1498.82,
    y2: 414.98,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-267",
    x1: 412.15,
    y1: 859.49,
    x2: 375.15,
    y2: 817.49,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-268",
    x1: 307.89,
    y1: 796.46,
    x2: 147.23,
    y2: 506.88,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-269",
    x1: 10212.78,
    y1: 513.34,
    x2: 10269.32,
    y2: 513.34,
    gradientTransform: "matrix(1, 0, 0, -1, -9962.55, 1475.4)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-270",
    x1: 10113.47,
    y1: 513.2,
    x2: 10139.94,
    y2: 513.2,
    gradientTransform: "matrix(1, 0, 0, -1, -9962.55, 1475.4)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-271",
    x1: 10124.66,
    y1: 531.44,
    x2: 10141.84,
    y2: 531.44,
    gradientTransform: "matrix(1, 0, 0, -1, -9962.55, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-272",
    x1: 10215.65,
    y1: 532.57,
    x2: 10229.97,
    y2: 532.57,
    gradientTransform: "matrix(1, 0, 0, -1, -9962.55, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-273",
    x1: 10251.27,
    y1: 752.65,
    x2: 10192.67,
    y2: 676.9,
    gradientTransform: "matrix(1, 0, 0, -1, -9962.55, 1475.4)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-274",
    x1: 138.48,
    y1: 728.21,
    x2: 346.48,
    y2: 877.71,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-275",
    x1: 313.45,
    y1: 969.04,
    x2: 285.95,
    y2: 868.04,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-276",
    x1: 9724.8,
    y1: 3248.38,
    x2: 9744.8,
    y2: 3163.88,
    gradientTransform: "matrix(1, 0, 0, -1, -9962.55, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-277",
    x1: 9709.9,
    y1: 3244.86,
    x2: 9729.9,
    y2: 3160.36,
    gradientTransform: "matrix(1, 0, 0, -1, -9962.55, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-278",
    x1: 245.22,
    y1: 1034.85,
    x2: 254.72,
    y2: 938.35,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-249"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-279",
    x1: 483.92,
    y1: 1058.35,
    x2: 493.42,
    y2: 961.85,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-249"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-280",
    x1: -2005.11,
    y1: 276.76,
    x2: -1925.11,
    y2: 349.76,
    gradientTransform: "translate(-1240.73 1475.4) rotate(180)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-281",
    x1: 104.65,
    y1: 775.3,
    x2: 312.64,
    y2: 924.8,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-282",
    x1: -1643.4,
    y1: 797.98,
    x2: -1586.46,
    y2: 647.07,
    gradientTransform: "translate(-1240.73 1475.4) rotate(180)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-283",
    x1: -1992.09,
    y1: 262.49,
    x2: -1912.09,
    y2: 335.49,
    gradientTransform: "translate(-1240.73 1475.4) rotate(180)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-284",
    x1: 3206.37,
    y1: 920.96,
    x2: 3254.89,
    y2: 792.38,
    gradientTransform: "matrix(1, 0, 0, -1, -1327.05, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-285",
    x1: 1849.54,
    y1: 912.13,
    x2: 1734.2,
    y2: 860.13,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-286",
    x1: 5411.37,
    y1: 597.44,
    x2: 5468.5,
    y2: 597.44,
    gradientTransform: "translate(7394.77 1475.4) rotate(180)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-287",
    x1: -4512.94,
    y1: 860.81,
    x2: -4517.61,
    y2: 728.81,
    gradientTransform: "translate(-2567.79 1475.4) rotate(180)",
    xlinkHref: "#linear-gradient-249"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-288",
    x1: 5311.02,
    y1: 597.31,
    x2: 5337.78,
    y2: 597.31,
    gradientTransform: "translate(7394.77 1475.4) rotate(180)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-289",
    x1: -4628.7,
    y1: 864.91,
    x2: -4633.37,
    y2: 732.91,
    gradientTransform: "translate(-2567.79 1475.4) rotate(180)",
    xlinkHref: "#linear-gradient-249"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-290",
    x1: 5322.34,
    y1: 615.72,
    x2: 5339.69,
    y2: 615.72,
    gradientTransform: "translate(7394.77 1475.4) rotate(180)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-291",
    x1: 5414.28,
    y1: 616.83,
    x2: 5428.74,
    y2: 616.83,
    gradientTransform: "translate(7394.77 1475.4) rotate(180)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-292",
    x1: 2008.04,
    y1: 930.35,
    x2: 1736.56,
    y2: 843.35,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-293",
    x1: 1926.68,
    y1: 1046.67,
    x2: 1936.68,
    y2: 976,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-294",
    x1: 1995.67,
    y1: 942.97,
    x2: 1937,
    y2: 814.3,
    gradientTransform: "matrix(0.91, 0.42, 0.42, -0.91, -426.16, 299.22)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-295",
    x1: 1571.48,
    y1: 913.89,
    x2: 1738.08,
    y2: 1134.66,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, 4.57, -124.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-296",
    x1: 2046.02,
    y1: 920.01,
    x2: 1987.36,
    y2: 791.35,
    gradientTransform: "matrix(1, -0.08, -0.08, -1, -151.5, 1368.51)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-297",
    x1: 508.76,
    y1: 2345.45,
    x2: 561.06,
    y2: 2206.87,
    gradientTransform: "matrix(0.75, 0.66, 0.66, -0.75, -46.1, 1970.46)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-298",
    x1: 1957.22,
    y1: 1002.18,
    x2: 1963.89,
    y2: 942.85,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-299",
    x1: 1997.16,
    y1: 964.33,
    x2: 1725.67,
    y2: 877.33,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-300",
    x1: 1902.14,
    y1: 995.99,
    x2: 1908.8,
    y2: 936.66,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-301",
    x1: 1929,
    y1: 1078.95,
    x2: 1922.34,
    y2: 1030.29,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-302",
    x1: 1942.49,
    y1: 1077.11,
    x2: 1935.82,
    y2: 1028.45,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-303",
    x1: 1973.51,
    y1: 259.05,
    x2: 1755.33,
    y2: -159.46,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-304",
    x1: 1957.88,
    y1: 330.53,
    x2: 1799.21,
    y2: -72.12,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1475.4)",
    xlinkHref: "#linear-gradient-15"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.65,148.1C226,288.3,464.19,439.16,351.1,519.19s-591.81,253-82.16,500.78,543.38,382.08,882.58,182,303.8-180,600.28-79.1,586-105.15,469-319.67-182.17-207.5-74.26-356.5-126.47-601.48-509.95-273-439,153-619.79,7C918.93,101.7,643.19-73.48,387.65,148.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M904,139.56a1,1,0,0,1-.82-.42c-.75-1.07-1.52-2.14-2.3-3.19a1,1,0,1,1,1.42-1.4.72.72,0,0,1,.17.22c.79,1.06,1.57,2.14,2.34,3.23a1,1,0,0,1-.24,1.38A1,1,0,0,1,904,139.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M775.9,386.17H773a1,1,0,0,1,0-2c1,0,1.9.05,2.85,0,1.6,0,3.22,0,4.83-.08a1,1,0,0,1,1,1,1,1,0,0,1-1,1h0C779.19,386.15,777.52,386.17,775.9,386.17Zm-15.4-.76h-.1c-2.56-.26-5.15-.58-7.71-1a1,1,0,0,1-.83-1.13,1,1,0,0,1,1.12-.83c2.53.37,5.09.69,7.62.94a1,1,0,0,1-.1,2Zm32.77-.22a1,1,0,0,1-.11-2c2.54-.29,5.09-.64,7.61-1a1,1,0,0,1,.32,2c-2.55.41-5.14.77-7.7,1.06Zm19.92-3.56a1,1,0,0,1-.23-2c2.15-.53,4.33-1.11,6.47-1.74l.94-.27a1,1,0,0,1,.83,1.82.92.92,0,0,1-.27.08l-.95.28c-2.17.63-4.37,1.22-6.55,1.76A.73.73,0,0,1,813.19,381.63Zm19.33-6.09a1,1,0,0,1-1-1,1,1,0,0,1,.61-.88c2.37-.91,4.75-1.9,7.08-2.94a1,1,0,0,1,.81,1.81c-2.36,1-4.78,2.06-7.18,3a.74.74,0,0,1-.33.05ZM850.91,367a1,1,0,0,1-.48-1.87c2.24-1.22,4.48-2.51,6.65-3.83a1,1,0,0,1,1.33,1.5,1.09,1.09,0,0,1-.33.19c-2.19,1.34-4.46,2.65-6.73,3.89a.93.93,0,0,1-.41.12ZM868,356.2a1,1,0,0,1-.8-.41,1,1,0,0,1,.22-1.39c2-1.49,4.1-3.06,6.08-4.66a1,1,0,0,1,1.24,1.55c-2,1.62-4.07,3.2-6.16,4.72a1,1,0,0,1-.55.19Zm15.56-13a1,1,0,0,1-.68-1.71c1.84-1.75,3.67-3.57,5.43-5.42a1,1,0,1,1,1.62,1.17.72.72,0,0,1-.19.2c-1.78,1.87-3.63,3.72-5.5,5.49a1,1,0,0,1-.65.31Zm13.76-14.87a1,1,0,0,1-.63-.22,1,1,0,0,1-.14-1.39c1.6-2,3.18-4,4.68-6.08a1,1,0,0,1,1.6,1.18c-1.52,2.08-3.12,4.14-4.74,6.15a1,1,0,0,1-.74.4Zm11.72-16.52a1,1,0,0,1-.52-.14,1,1,0,0,1-.32-1.37c1.34-2.17,2.64-4.4,3.87-6.63a1,1,0,1,1,1.74,1c-1.25,2.26-2.57,4.52-3.92,6.71a1,1,0,0,1-.82.47Zm9.51-17.89a.93.93,0,0,1-.4-.09,1,1,0,0,1-.5-1.31c1.05-2.32,2.05-4.7,3-7.07a1,1,0,1,1,1.84.73c-.94,2.4-2,4.81-3,7.16a1,1,0,0,1-.91.62Zm7.14-19a.71.71,0,0,1-.29,0,1,1,0,0,1-.66-1.24c.74-2.44,1.43-4.93,2-7.4a1,1,0,0,1,1.31-.54,1,1,0,0,1,.61,1c-.62,2.51-1.32,5-2.07,7.5a1,1,0,0,1-.87.73Zm4.62-19.73h-.15a1,1,0,0,1-.82-1.15c.42-2.51.79-5.07,1.08-7.6a1,1,0,0,1,2,.23c-.3,2.56-.66,5.15-1.09,7.7a1,1,0,0,1-1,.89Zm2-20.17h0a1,1,0,0,1-1-1c.06-1.78.09-3.59.09-5.37v-2.31a1,1,0,0,1,2,0v2.34c0,1.81,0,3.64-.09,5.44a1,1,0,0,1-.94,1Zm-.62-20.27a1,1,0,0,1-1-.9c-.24-2.53-.55-5.09-.92-7.62a1,1,0,0,1,2-.28h0c.38,2.56.69,5.15.94,7.71a1,1,0,0,1-.9,1.09Zm-3.24-20a1,1,0,0,1-1-.78c-.57-2.48-1.2-5-1.89-7.43a1,1,0,1,1,1.84-.77.62.62,0,0,1,.07.23c.69,2.48,1.34,5,1.92,7.53a1,1,0,0,1-.75,1.19l-.13.1Zm-5.77-19.43a1,1,0,0,1-.93-.65c-.89-2.4-1.84-4.8-2.83-7.14a1,1,0,0,1,1.7-1.05.77.77,0,0,1,.12.28c1,2.37,2,4.8,2.87,7.22a1,1,0,0,1-.59,1.28.9.9,0,0,1-.28.13Zm-8.22-18.53a1,1,0,0,1-.88-.53c-1.18-2.26-2.43-4.52-3.72-6.71a1,1,0,1,1,1.71-1c1.3,2.22,2.57,4.5,3.77,6.79a1,1,0,0,1-.42,1.34.86.86,0,0,1-.4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M740.44,382.08h-.23c-1.3-.31-2.59-.64-3.87-1a1,1,0,0,1,.26-2l.24.06c1.27.33,2.54.65,3.82.95a1,1,0,0,1-.22,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M642.75,311.92a1,1,0,0,1-.84-.48c-.7-1.13-1.39-2.27-2.06-3.42a1,1,0,0,1,1.72-1c.66,1.14,1.34,2.27,2,3.38a1,1,0,0,1-.32,1.37A.89.89,0,0,1,642.75,311.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M634.62,297a1,1,0,0,1-.9-.56c-1.15-2.42-2.25-4.91-3.28-7.39a1,1,0,0,1,1.84-.76c1,2.45,2.1,4.9,3.24,7.29a1,1,0,0,1-.47,1.33A1,1,0,0,1,634.62,297Zm-7.75-19.6a1,1,0,0,1-.94-.69c-.42-1.31-.83-2.64-1.22-4s-.71-2.52-1-3.78a1,1,0,0,1,.7-1.21,1,1,0,0,1,1.22.7c.33,1.25.67,2.49,1,3.74s.78,2.63,1.2,3.93a1,1,0,0,1-.64,1.25.87.87,0,0,1-.32.06Zm-5.07-20.45a1,1,0,0,1-1-.82c-.47-2.65-.88-5.34-1.21-8a1,1,0,1,1,2-.24c.33,2.62.74,5.28,1.2,7.89a1,1,0,0,1-.8,1.15Zm-2.3-21a1,1,0,0,1-1-.95c-.09-2.15-.13-4.32-.13-6.47v-1.62a1,1,0,0,1,2,0v1.6c0,2.12,0,4.27.13,6.38a1,1,0,0,1-1,1Zm.56-21.08H620a1,1,0,0,1-.89-1.08c.25-2.68.58-5.38,1-8a1,1,0,0,1,2,.29c-.39,2.63-.71,5.29-1,7.94a1,1,0,0,1-1,.9Zm3.41-20.8a.88.88,0,0,1-.23,0,1,1,0,0,1-.74-1.19c.61-2.61,1.3-5.25,2-7.82a1,1,0,1,1,2,.27.9.9,0,0,1-.08.28c-.73,2.54-1.41,5.14-2,7.72a1,1,0,0,1-1,.79Zm6.17-20.15a.84.84,0,0,1-.35-.07,1,1,0,0,1-.58-1.28c1-2.5,2-5,3.08-7.48a1,1,0,1,1,1.81.8c-1.07,2.43-2.09,4.92-3,7.39a1,1,0,0,1-1,.69Zm8.81-19.15a1,1,0,0,1-.87-1.46c1.28-2.36,2.64-4.71,4-7a1,1,0,0,1,1.7,1c-1.39,2.26-2.73,4.59-4,6.91a1,1,0,0,1-.83.6ZM649.74,137a1,1,0,0,1-1-1,1,1,0,0,1,.18-.57c1.58-2.16,3.25-4.31,4.94-6.39a1,1,0,0,1,1.42,0,1,1,0,0,1,.12,1.21c-1.68,2.06-3.32,4.18-4.88,6.31a1,1,0,0,1-.8.46Zm13.57-16.12a1,1,0,0,1-.69-1.68c1.86-1.93,3.8-3.84,5.75-5.67a1,1,0,0,1,1.36,1.45c-1.93,1.81-3.84,3.69-5.68,5.6a1,1,0,0,1-.74.35Zm15.6-14.13a1,1,0,0,1-.61-1.77c2.1-1.67,4.27-3.29,6.46-4.84a1,1,0,1,1,1.14,1.61c-2.15,1.53-4.3,3.14-6.37,4.78A1,1,0,0,1,678.91,106.7Zm17.37-11.91a1,1,0,0,1-.5-1.85c2.31-1.36,4.68-2.68,7.06-3.92a1,1,0,0,1,.92,1.76c-2.35,1.22-4.7,2.53-7,3.87a1,1,0,0,1-.48.18Zm18.83-9.45a1,1,0,0,1-1-1,1,1,0,0,1,.58-.88c2.46-1,5-2,7.52-2.94a1,1,0,0,1,.68,1.87c-2.5.9-5,1.87-7.44,2.9a.89.89,0,0,1-.38.12ZM735,78.49a1,1,0,0,1-.26-2c2.6-.71,5.24-1.35,7.85-1.92a1,1,0,0,1,1.28.62,1,1,0,0,1-.62,1.27,1,1,0,0,1-.24.05c-2.58.56-5.19,1.2-7.75,1.89a.79.79,0,0,1-.26.13Zm70.64-2.62h-.19c-2.6-.5-5.25-1-7.87-1.32a1,1,0,0,1,.27-2c2.66.37,5.34.82,8,1.34a1,1,0,1,1-.19,2h0Zm-50-1.53a1,1,0,0,1-.13-2c2.67-.35,5.37-.64,8-.85a1,1,0,0,1,.16,2c-2.64.21-5.31.49-7.94.83Zm29.07-1.08h-.06c-2.64-.15-5.33-.23-8-.25a1,1,0,0,1,0-2h0c2.69,0,5.4.1,8.08.25a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M822.25,80.08a.71.71,0,0,1-.29,0c-1.26-.39-2.52-.76-3.78-1.12a1,1,0,0,1-.53-1.31,1,1,0,0,1,1.07-.6c1.28.36,2.56.74,3.82,1.14a1,1,0,0,1-.29,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M825.71,119.16a1.9,1.9,0,0,0-2.18.19l-17.41,14.82a99.55,99.55,0,0,0-31.93-4.54L761.6,110.56a1.89,1.89,0,0,0-2-.78L733,116.61a1.86,1.86,0,0,0-1.4,1.67l-1.84,22.77A100.07,100.07,0,0,0,704,160.45l-22.4-4.58a1.89,1.89,0,0,0-2,.89l-14,23.61a1.88,1.88,0,0,0,.18,2.17L680.61,200a99.71,99.71,0,0,0-4.54,32L657,244.5a1.89,1.89,0,0,0-.78,2l6.83,26.56a1.89,1.89,0,0,0,1.67,1.41l22.78,1.83a99.47,99.47,0,0,0,19.39,25.79l-4.58,22.4a1.87,1.87,0,0,0,.89,2l23.61,14a1.88,1.88,0,0,0,2.18-.19l17.41-14.82a99.44,99.44,0,0,0,32,4.54l12.59,19.07a1.88,1.88,0,0,0,2,.78L819.5,343a1.86,1.86,0,0,0,1.4-1.67l1.83-22.77a99.45,99.45,0,0,0,25.79-19.4l22.41,4.58a1.88,1.88,0,0,0,2-.89l14-23.61a1.87,1.87,0,0,0-.19-2.17L871.9,259.7a99.39,99.39,0,0,0,4.55-32l19.06-12.6a1.86,1.86,0,0,0,.79-2l-6.84-26.56a1.89,1.89,0,0,0-1.66-1.41L865,183.3a99.29,99.29,0,0,0-19.4-25.79l4.58-22.4a1.88,1.88,0,0,0-.88-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M776.29,255.7a25.62,25.62,0,1,1,24.55-18.29A25.65,25.65,0,0,1,776.29,255.7Zm-.1-48.76a22.93,22.93,0,1,0,6.49.94A22.94,22.94,0,0,0,776.19,206.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M776,298a67.8,67.8,0,0,1-65.54-50.81,68.6,68.6,0,0,1-2.16-17,67.76,67.76,0,0,1,50.88-65.39,68.8,68.8,0,0,1,13-2h1.21l.12,3a66.06,66.06,0,0,0-13.63,2h0q-2.26.58-4.47,1.32a64.16,64.16,0,0,0-33,25l-.66,1c-.51.8-1,1.6-1.5,2.42a64.7,64.7,0,1,0,101.21-13.09l2.09-2.12A67.69,67.69,0,0,1,776,298.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M687.3,942.77S572.66,365.6,303.19,43.17c-18.11-21.68-53-14.86-61.45,12.1C185.19,235.51,69.41,784.25,687.3,942.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M631.64,903.79a1.55,1.55,0,0,1-2.1,2.28c-56.22-45.09-271.93-264.43-339-688.3a1.09,1.09,0,0,1,2.13-.46C317.1,315.89,418.64,679.79,631.64,903.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M609.93,993.48s-219-456.39-512.59-667.39c-19.73-14.19-47.34-1-48.61,23.23C40.19,511.6,61.19,993.62,609.93,993.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M555.19,972.91a1.34,1.34,0,0,1,.39,1.86,1.33,1.33,0,0,1-1.66.49c-56.47-25.56-283.15-162.14-429.73-501a.94.94,0,0,1,1.67-.85C167.31,550.35,329.79,831.85,555.19,972.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1958.37,754.22s-18.35-214.16,100.4-280.1c113.92-63.25,145.72-7.25,198-91.24a4.8,4.8,0,0,1,8.85,1.89c6.27,48,16.88,210.76-120.63,243.17C1986.1,665.38,1958.37,754.22,1958.37,754.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2244.46,431.84a73.23,73.23,0,0,1-5,12c-1.06,1.92-2,3.89-3.15,5.75l-3.43,5.59c-2.55,3.56-4.91,7.25-7.75,10.59-1.38,1.7-2.71,3.43-4.12,5.11l-4.43,4.85a217.55,217.55,0,0,1-40.29,33.53c-14.51,9.86-30.36,17.55-46.29,24.84L2117.8,539c-4,1.65-8.11,3.29-12.28,4.89l-6.21,2.44-6.14,2.62c-4.12,1.68-8.11,3.67-12.16,5.52a266,266,0,0,0-23.54,12.73c-3.87,2.24-7.55,4.79-11.3,7.22-3.64,2.61-7.34,5.13-10.84,7.94a192.36,192.36,0,0,0-37.66,38.38A211.76,211.76,0,0,0,1971.85,668c-6.66,16.62-11.66,33.78-16.66,50.7h0a4.65,4.65,0,0,0,8.91,2.64v-.08c4.73-17,9.32-33.94,15.55-50.19a203.93,203.93,0,0,1,24.07-45.91,185.38,185.38,0,0,1,35.67-37.59c3.34-2.78,6.9-5.29,10.39-7.89,3.62-2.42,7.16-5,10.9-7.22,7.34-4.7,15-8.86,22.82-12.85,3.94-1.89,7.83-3.91,11.86-5.63l6-2.68,6.08-2.5c4-1.63,8.14-3.37,12.23-5.12l12.27-5.21c16-7.66,31.93-15.73,46.51-26a221.85,221.85,0,0,0,40.33-34.77c11.75-13.3,22.27-28.08,27.7-45.36a1,1,0,0,0-.59-1.28l-.09,0a1,1,0,0,0-1.28.61.19.19,0,0,1,0,.07h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1936.66,796.06l15.68-9.29c-7.93-122,14.29-345.93,136.14-407,82.54-41.34,113.24-87.43,107.09-185.89-4.11-65.68,17.68-111.08,32.63-134a5.46,5.46,0,0,0-7-7.89c-50.31,24.81-181.4,98.24-241.37,215C1904.76,413.11,1936.66,796.06,1936.66,796.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2143.53,133.7a133.41,133.41,0,0,0-17.73,12.16c-2.78,2.22-5.58,4.41-8.2,6.8l-4,3.52-2,1.76-1.91,1.84-7.64,7.4c-2.47,2.54-4.86,5.15-7.3,7.73l-3.63,3.88c-1.21,1.29-2.31,2.68-3.47,4l-6.88,8.1c-18,21.84-33.54,45.64-47.31,70.31l-5.18,9.24-1.29,2.32-1.19,2.37-2.37,4.73-9.48,19-8.62,19.36-4.3,9.68c-1.36,3.26-2.59,6.57-3.9,9.85l-7.72,19.73c-1.33,3.27-2.47,6.61-3.64,9.94l-3.52,10c-2.2,6.71-4.41,13.42-6.5,20.17l-3,10.15-1.51,5.08-1.4,5.11c-7.57,27.21-13.82,54.78-18.92,82.55s-9.08,55.73-12.09,83.79c-1.54,14-2.76,28.09-3.85,42.16s-1.84,28.16-2.44,42.26-1,28.21-1.07,42.34,0,28.2.58,42.45a4.65,4.65,0,0,0,9.29-.39V753c-.68-13.85-.87-27.93-.88-41.92s.27-28,.76-42,1.2-28,2.13-42,2.09-28,3.51-41.91q4.19-41.85,11.41-83.31t18.13-82.14l1.35-5.07,1.47-5.05,2.92-10.09c2-6.7,4.17-13.36,6.3-20l3.42-9.93c1.14-3.31,2.24-6.64,3.54-9.89l7.52-19.62c1.27-3.27,2.47-6.56,3.79-9.8l4.19-9.63,8.41-19.26,9.26-18.85,2.31-4.71,1.16-2.36,1.26-2.3,5.07-9.19c13.45-24.53,28.63-48.18,46.27-69.87l6.73-8c1.13-1.33,2.21-2.71,3.39-4l3.56-3.85c2.38-2.55,4.71-5.15,7.13-7.67l7.46-7.33,1.87-1.83,1.95-1.74,3.9-3.48c2.56-2.37,5.28-4.53,8-6.72s5.51-4.21,8.29-6.29a79,79,0,0,1,8.63-5.54l.12-.06a2.19,2.19,0,0,0-2.13-3.83h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M458.19,1358.22H102.76a20.52,20.52,0,0,1-20.52-20.52h0V994.56A20.52,20.52,0,0,1,102.7,974l358.23-1a20.52,20.52,0,0,1,20.58,20.46v.2l-2.85,344.1A20.5,20.5,0,0,1,458.19,1358.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M440.73,999.35,123,1001.3a20.81,20.81,0,0,0-20.69,20.92l2.21,288.6a20.82,20.82,0,0,0,20.44,20.72l308.76,5.64a20.83,20.83,0,0,0,21.2-20.45v-.08l6.8-296.19a20.82,20.82,0,0,0-20.53-21.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 170.51,
    y: 1019.88,
    width: 257.3,
    height: 14.65,
    rx: 6.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M400.49,1053.7h0a6.21,6.21,0,0,1-6.1,5.89l-214.13,3.9a6.23,6.23,0,0,1-6.34-6.12v-.67a6.22,6.22,0,0,1,6.13-6.22l214.14-3.38a6.23,6.23,0,0,1,6.31,6.15C400.5,1053.4,400.5,1053.55,400.49,1053.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M422.35,1320.85h-.16l-289.62-3.47a17.75,17.75,0,0,1-17.53-18v-.11l7.45-203.79a17.63,17.63,0,0,1,5.44-12.4,17.85,17.85,0,0,1,12.65-5l289.11,5.63a17.77,17.77,0,0,1,17.4,18.06h0l-7,201.59A17.76,17.76,0,0,1,422.35,1320.85ZM140.19,1084a11.86,11.86,0,0,0-11.85,11.66l-7.45,203.8a11.85,11.85,0,0,0,11.7,12h0l289.6,3.45h.14a11.86,11.86,0,0,0,11.86-11.63l7-201.62a11.87,11.87,0,0,0-11.61-12l-289.12-5.62Zm303.91,17.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M440.33,1123.36H124.92a3,3,0,0,1,0-5.91H440.33a3,3,0,1,1,0,5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1963.71,1256.7c0,17.23-13,31.32-28.78,31.32H378.57c-15.83,0-28.78-14.09-28.78-31.32l-13-974c0-17.22,18.63-50.84,52.77-48.32l1521.05-42.85c19.86-.56,39.07,7.76,53.13,23s21.76,36.14,21.29,57.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1935.29,1226.61c0,16.31-12.25,29.66-27.22,29.66h-1492c-15,0-27.23-13.35-27.23-29.66L376.65,342.43c1.44-53.21,44.28-72.33,70.24-71.2l1457.79-42.59A48.83,48.83,0,0,1,1942,244.82a58.21,58.21,0,0,1,15,40.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M489.19,1225c-24.06,0-44.07-18.91-44.74-42.41l-23.39-824.7c-.68-23.86,18.68-44,43.15-44.8l1411.48-48.57A45.51,45.51,0,0,1,1909,277.38a42.7,42.7,0,0,1,13,31.36l-12.07,857.32c-.33,23.84-19.75,42.73-44.21,43l-1376,16ZM464.3,315.1l.07,2c-22.3.76-39.94,19-39.33,40.71l23.4,824.71c.6,21.36,18.85,38.56,40.77,38.56h.48l1376-15.95c22.29-.26,40-17.44,40.3-39.11l12.08-857.32a38.77,38.77,0,0,0-11.83-28.46,41.47,41.47,0,0,0-30.4-11.7L464.37,317.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M262.58,1283.24H2082.46a7.5,7.5,0,0,1,7.5,7.5v70.57a7.51,7.51,0,0,1-7.51,7.51H262.58a7.51,7.51,0,0,1-7.51-7.51h0V1290.7A7.51,7.51,0,0,1,262.58,1283.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M489.64,336.7,1501.19,313c16.45-.39,30.07,9.4,30.07,21.6v11.25c0,11.72-12.6,21.31-28.41,21.61l-1011.12,19c-15.82.3-29.07-8.82-29.85-20.54l-.44-6.53C460.64,347.33,473.34,337.12,489.64,336.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1501.05,339.84c2.15-17.14-9.75-32.74-26.57-34.84s-32.21,10.07-34.36,27.2a31.44,31.44,0,0,0,6.85,23.89l-31.32,24.1a4.37,4.37,0,0,0-.67,6.13c.07.09.15.17.22.25l.29.31a4.06,4.06,0,0,0,5.73.18l0,0,28.45-28a30.17,30.17,0,0,0,17,8C1483.53,369.15,1498.91,357,1501.05,339.84Zm-33.31,18.91A22.91,22.91,0,1,1,1493,338.4c0,.14,0,.28,0,.42a22.72,22.72,0,0,1-25.16,19.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M470.59,772.23l16.87,377.58c.57,12.72,19.78,22.83,43.07,22.65l495.23-3.72c23.29-.18,42-10.56,41.92-23.29L1066,764.34c-.06-13-19.75-23.5-43.61-23.16L512,748.44C488.53,748.78,470,759.42,470.59,772.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1162.9,413.81,1473.36,410c31.77-.39,58.12,9.93,58.39,22.87L1537,689.46c.27,12.92-25.62,23.42-57.39,23.26l-323.2-1.61c-18.19-.1-32.93-6-33.36-13.42l-15.16-260.27C1107.19,424.7,1131.74,414.19,1162.9,413.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M548.51,407.94l441.79-3.89c45.22-.4,82.71,10.24,83.09,23.57l7.5,264.4c.38,13.32-36.46,24.14-81.67,24L539.3,714.36c-25.88-.09-46.86-6.21-47.47-13.83L470.26,432.27C469.19,419.2,504.19,408.33,548.51,407.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1162.19,743.7l310.46-5.55c31.78-.56,58.12,14.59,58.39,33.58l5.27,376.68c.27,19-25.62,34.39-57.39,34.16l-323.2-2.37c-18.18-.14-32.93-8.85-33.36-19.71l-15.17-382.1C1106.44,759.77,1131,744.28,1162.19,743.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1617.93,301.58l242.2-3.9c24.79-.39,45.35,10.26,45.55,23.63l4.12,265c.2,13.35-20,24.19-44.78,24l-252.14-1.61c-14.19-.09-25.69-6.22-26-13.86L1575.06,326C1574.45,312.87,1593.61,302,1617.93,301.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1623.88,645.91l242.2-3.06c24.79-.31,45.35,8,45.55,18.53l4.12,207.92c.2,10.48-20,19-44.78,18.86l-252.14-1.31c-14.19-.07-25.69-4.88-26-10.88L1581,665C1580.4,654.76,1599.56,646.22,1623.88,645.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1635.43,919.91l242.2-3.26c24.79-.34,45.35,8.57,45.56,19.74l4.11,221.43c.21,11.16-20,20.22-44.78,20.08l-252.14-1.39c-14.19-.08-25.69-5.2-26-11.58l-11.82-224.65C1592,929.34,1611.12,920.23,1635.43,919.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1409.09,746.55h-264.9c-8.45,0-15.29-5.06-15.29-11.3V546.32c0-6.23,6.82-11.28,15.25-11.3l267-.53c8.5,0,15.38,5.09,15.34,11.36l-2.12,189.46C1424.34,741.53,1417.51,746.55,1409.09,746.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1396.12,549,1159.28,550c-8.56,0-15.46,5.19-15.42,11.52l1.65,158.9c0,6.23,6.81,11.3,15.24,11.41l230.11,3.1c8.59.12,15.68-5,15.8-11.3l5.07-163.08C1411.85,554.16,1404.81,548.91,1396.12,549Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1386.49,563.7v1.21c0,1.89-2.08,3.43-4.65,3.43H1199.37c-2.57,0-4.65-1.54-4.65-3.43V563.7c0-1.89,2.08-3.43,4.65-3.43h182.47C1384.41,560.26,1386.49,561.8,1386.49,563.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1366.13,578.86h0c-.14,1.8-2.12,3.21-4.55,3.25L1202,584.26c-2.6,0-4.73-1.52-4.73-3.43v-.28c0-1.88,2-3.4,4.57-3.43l159.59-1.87C1364.11,575.22,1366.27,576.88,1366.13,578.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1382.42,726.55h-.16l-215.85-1.91a14.63,14.63,0,0,1-10.41-4.09,9,9,0,0,1-2.66-6.47l5.56-112.23c.14-5.58,6-10.09,13.22-10.09h.25l215.47,3.1a14.63,14.63,0,0,1,10.33,4.11,9,9,0,0,1,2.65,6.43h0l-5.18,111C1395.5,722.12,1389.71,726.55,1382.42,726.55Zm-210.3-130.39c-4.72,0-8.74,2.65-8.82,5.85l-5.56,112.24a4.62,4.62,0,0,0,1.43,3.24,10.32,10.32,0,0,0,7.28,2.74l215.85,1.92h.11c4.72,0,8.75-2.66,8.83-5.85l5.18-111A4.72,4.72,0,0,0,1395,602a10.34,10.34,0,0,0-7.23-2.76l-215.47-3.09Zm226.5,9.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1395.82,617.81H1160.75a2.2,2.2,0,0,1,0-4.4h235.07a2.2,2.2,0,1,1,0,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1216.64,740.76S1271,810.4,1209,881.23l-23.34-2.17s44.92-72.12,24.91-129.61l-33,2.42L1159.19,740Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1186.85,1081.7s-44.07,96-67.19,135.84c0,0-4.6,25,0,32.91l3.91,1.74-18.27-.55s-1.62-33.67-.35-35.55a4.68,4.68,0,0,1,3.8-1.76s7.83-62,30.52-75.3l22-75.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1131.37,1256.93c0,.44-14.26.24-22,.1a6.19,6.19,0,0,1-5.93-4.87l-5.86-30.8a5.53,5.53,0,0,1,4.21-6.43l3.27-.75s4.67,6.4,3.2,12.43-2.78,21.65.94,23.47,14.39,2.14,14.39,2.14S1131.13,1253,1131.37,1256.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1228.62,1257.49a1.61,1.61,0,0,1-.81,3c-13-.13-42.1-.54-44.69-1.61-3.34-1.39,1.22-13.39,6-17.45l26.48,8.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1236.84,1075.6s-28.48,137.78-36.53,164.66l19,12s-9.55-1.63-16.63-2.14-13.6-8.64-13.6-8.64l2.29-3.65s7.14-137,5.4-152.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1307.54,754.24s3.93,71.67-61.32,108.29l15.71,35.83s59.07-35.73,56.89-133.19a11.36,11.36,0,0,1,2.77-7.63l12.6-14.57a22.53,22.53,0,0,0,4.79-20.18l-1.65-6.61a3.43,3.43,0,0,0-4.2-2.45,3.26,3.26,0,0,0-.8.32l-1.31.76a23,23,0,0,0-9.46,10.52l-6.17,13.79a13.22,13.22,0,0,1-13.23,7.78l-3.81-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1248.49,857.16c-10.92,3-47.9,12.76-71,12.36l14.18,80-1.13,13,46.22-.21s13-30.21,23.27-45.28c3-4.35.76-9.54-.92-14.53l2.31-1.53a6.28,6.28,0,0,0,2.49-7.19l-11.25-34.43A3.45,3.45,0,0,0,1248.49,857.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1240.47,955.53l-.91,7.9s13.06,39.12-6.53,130.48c0,0-42.43,12-77.31-16.75,0,0,9.84-86.23,12.53-90.24,13.38-20,22.3-24.36,22.3-24.36l.4-8.63S1228.25,960.7,1240.47,955.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1222.38,863.61c.16-.22-9.65-29.62-9.65-29.62l-14.06,1.27-5.48,33.36S1215.19,873.07,1222.38,863.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1202,787.61c.94.58,30,12.61,23.78,42.81a5.63,5.63,0,0,1-3.23,4,49.09,49.09,0,0,1-24.45,4c-15.24-1.55-25.23-28.14-24.8-35.88S1192.75,781.83,1202,787.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1193.19,775.87c5.82.76,11.78,6.71,10.93,12.8-.82,5.86-7.1,7.14-9.92,11.38-6.52,9.81-.59,26.58,5.47,35.34,18.24,26.34,48.15,58.33,27.64,92.66-13.32,22.29-43,34.92-68.27,32.1-13.43-1.5-26.45-15.48-32.79-26.69-8.9-15.76-10.53-35.56-5.76-52.91,4.63-16.78,19.56-30,29.38-44,3.54-5,7-10.66,6.9-16.83,0-3.85-1.49-7.55-1.93-11.38C1152.63,788.78,1175.87,773.59,1193.19,775.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1150.19,935.18l.44-.71c-9.33-5.81-15.14-17.44-15.14-30.35,0-10.25,3.2-21,10.09-33.79,2.57-4.77,5.44-9.48,8.22-14,3.34-5.48,6.8-11.15,9.76-17,2.67-5.24,5.19-11.42,3.71-17.47a32.66,32.66,0,0,0-4.08-8.58c-2.58-4.28-5-8.32-3.73-12.74l-.81-.23c-1.37,4.77,1.26,9.16,3.82,13.41a31.58,31.58,0,0,1,4,8.34c1.42,5.79-1,11.78-3.64,16.89-2.94,5.8-6.39,11.45-9.73,16.92-2.78,4.57-5.66,9.29-8.24,14.07-7,12.93-10.2,23.8-10.2,34.19C1134.66,917.32,1140.62,929.22,1150.19,935.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1156.66,933.38l.69-.49c-7.33-10.34-10-24.79-7.36-39.64s9.87-28.14,15.88-38.18l-.72-.43c-6,10.1-13.33,23.6-16,38.46C1146.48,908.17,1149.19,922.85,1156.66,933.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1499.73,809.4l-1.6,2.16a.65.65,0,0,1-.9.13.64.64,0,0,1-.13-.89h0l1.6-2.14h0a.65.65,0,0,1,.89-.12A.63.63,0,0,1,1499.73,809.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1494.31,816.53l-1.68,2.1a.64.64,0,0,1-.91.12h0a.66.66,0,0,1-.1-.93h0l1.67-2.09h0a.65.65,0,0,1,.9-.12h0A.65.65,0,0,1,1494.31,816.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1488.66,823.48l-1.74,2a.67.67,0,0,1-.94-.07.68.68,0,0,1-.06-.8h0l1.74-2h0a.66.66,0,1,1,1,.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1482.79,830.24l-1.8,2a.7.7,0,0,1-1,.06h0a.68.68,0,0,1,0-1l0,0h0l1.8-2h0a.69.69,0,0,1,1,.11.68.68,0,0,1,0,.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1476.71,836.81l-1.87,1.94a.7.7,0,0,1-1,0h0a.68.68,0,0,1,0-1l0,0h0l1.87-1.92h0a.71.71,0,0,1,1.09.91l-.09.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1470.42,843.19l-1.92,1.87a.73.73,0,1,1-1.26-.74.81.81,0,0,1,.26-.26h0l1.92-1.86h0a.74.74,0,0,1,1,0A.73.73,0,0,1,1470.42,843.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1463.94,849.37l-2,1.81a.75.75,0,0,1-1.06-1.06h0l2-1.8h0a.75.75,0,0,1,1,0,.73.73,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1457.27,855.34l-2,1.75a.77.77,0,1,1-1.12-1.05l.12-.11h0l2-1.73h0a.77.77,0,0,1,1.08.08.76.76,0,0,1-.08,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1450.41,861.11l-2.09,1.68a.78.78,0,0,1-1.1,0l0,0a.79.79,0,0,1,.12-1.11h0l2.09-1.67h0a.8.8,0,0,1,1.11.11.78.78,0,0,1-.11,1.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1443.38,866.7l-2.14,1.62a.8.8,0,0,1-1.12-.15h0a.81.81,0,0,1,.15-1.13h0l2.14-1.61h0a.82.82,0,0,1,1.14.14.81.81,0,0,1-.14,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1436.19,872l-2.2,1.55a.81.81,0,0,1-1.14-.18h0a.83.83,0,0,1,.2-1.15h0l2.15-1.5h0a.84.84,0,0,1,1.17.17.83.83,0,0,1-.17,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1428.81,877.09l-2.24,1.49a.84.84,0,0,1-.93-1.4h0l2.23-1.47h0a.84.84,0,0,1,1.16.24.83.83,0,0,1-.24,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1421.29,882l-2.28,1.42a.86.86,0,0,1-1.19-.28.87.87,0,0,1,.28-1.19h0l2.28-1.4h0a.87.87,0,0,1,1.18.28A.85.85,0,0,1,1421.29,882Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1413.63,886.61,1411.3,888a.87.87,0,0,1-1.2-.32.88.88,0,0,1,.32-1.21h0l2.32-1.33h0a.88.88,0,0,1,.87,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1405.82,891l-2.37,1.28a.9.9,0,1,1-.85-1.59h0l2.36-1.26h0a.89.89,0,0,1,1.21.37.88.88,0,0,1-.37,1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1397.88,895.17l-2.4,1.2a.91.91,0,0,1-1.19-.51.92.92,0,0,1,.37-1.13h0l2.4-1.18h0a.91.91,0,1,1,.81,1.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1389.82,899.08l-2.45,1.12a.94.94,0,0,1-1.29-.33.94.94,0,0,1,.34-1.29l.17-.08h0l2.44-1.11h0a.94.94,0,0,1,1.24.46.93.93,0,0,1-.46,1.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1381.63,902.7l-2.47,1a1,1,0,0,1-.75-1.76h0l2.46-1h0a1,1,0,0,1,1.24.51A.94.94,0,0,1,1381.63,902.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1373.34,906.13l-2.51,1a1,1,0,1,1-1.15-1.63.93.93,0,0,1,.45-.18h0l2.5-1h0a1,1,0,0,1,.69,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1364.94,909.26l-2.54.88a1,1,0,1,1-.92-1.77,1,1,0,0,1,.27-.1h0l2.52-.87h0a1,1,0,0,1,.92,1.78,1.22,1.22,0,0,1-.27.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1356.44,912.12l-2.56.8a1,1,0,1,1-.61-1.93h0l2.55-.79h0a1,1,0,0,1,.62,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1347.86,914.7l-2.59.72a1,1,0,0,1-1.25-.65l0-.06a1,1,0,0,1,.66-1.25l0,0h0l2.57-.71h0a1,1,0,1,1,.55,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1339.19,917l-2.61.63a1,1,0,0,1-.5-2h0l2.59-.62h0a1,1,0,1,1,.49,2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1330.46,919l-2.64.55a1.06,1.06,0,1,1-.44-2.08h0L1330,917h0a1.08,1.08,0,0,1,1.26.83A1.05,1.05,0,0,1,1330.46,919Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1321.66,920.77l-2.65.47a1.09,1.09,0,0,1-.38-2.14h0l2.63-.45h0a1.08,1.08,0,0,1,.55,2.09l-.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1312.81,922.23l-2.66.39a1.1,1.1,0,1,1-.31-2.18h0l2.64-.37h0a1.09,1.09,0,0,1,1.24.92v0A1.08,1.08,0,0,1,1312.81,922.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1303.92,923.41l-2.67.3a1.13,1.13,0,0,1-1.23-1,1.09,1.09,0,0,1,1-1.21h0l2.65-.28h0a1.13,1.13,0,0,1,1.23,1,1.11,1.11,0,0,1-1,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1295,924.3l-2.68.22a1.12,1.12,0,0,1-.18-2.24h0l2.67-.21h0a1.12,1.12,0,1,1,.3,2.22H1295Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1286.05,924.92l-2.68.13a1.13,1.13,0,0,1-1.1-1.17,1.15,1.15,0,0,1,1-1.1h0l2.67-.12h0a1.13,1.13,0,0,1,.1,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1277.09,925.25l-2.69,0a1.15,1.15,0,0,1,0-2.29h2.67a1.14,1.14,0,1,1,0,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1268.12,925.31h-2.69a1.16,1.16,0,0,1-1-1.26,1.17,1.17,0,0,1,1-1h2.67a1.16,1.16,0,0,1,0,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1259.19,925.09l-2.69-.12a1.17,1.17,0,0,1,.11-2.33h0l2.67.12h0a1.16,1.16,0,1,1-.11,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1250.19,924.59l-2.69-.2a1.18,1.18,0,0,1,.18-2.35h0l2.67.21h0a1.17,1.17,0,0,1-.16,2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1241.26,923.82l-2.68-.28a1.19,1.19,0,1,1,.25-2.37h0l2.65.29h0a1.19,1.19,0,0,1-.25,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1232.35,922.77l-2.67-.37a1.19,1.19,0,0,1-.91-1.43A1.2,1.2,0,0,1,1230,920h0l2.65.37h0a1.2,1.2,0,0,1-.31,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1223.47,921.45l-2.65-.45a1.21,1.21,0,0,1,.41-2.39h0l2.63.45h0a1.21,1.21,0,0,1,1,1.37v0A1.22,1.22,0,0,1,1223.47,921.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1214.65,919.85l-2.64-.53a1.22,1.22,0,0,1-1-1.42v0a1.21,1.21,0,0,1,1.38-1h.06l2.61.54h0a1.22,1.22,0,0,1-.48,2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1205.87,918l-2.62-.62a1.23,1.23,0,0,1,.57-2.4h0l2.6.62h0a1.23,1.23,0,0,1-.55,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1197.19,915.83l-2.6-.7a1.24,1.24,0,0,1,.65-2.4h0l2.58.7h0a1.24,1.24,0,1,1-.65,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1188.52,913.41l-2.58-.78a1.25,1.25,0,0,1,.73-2.4h0l2.55.78h0a1.25,1.25,0,1,1-.73,2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1180,910.7l-2.55-.86a1.27,1.27,0,1,1,.81-2.41h0l2.52.86h0a1.27,1.27,0,0,1-.81,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M1171.49,907.75l-2.52-.94a1.27,1.27,0,0,1-.86-1.59,1.29,1.29,0,0,1,1.6-.86l.16.06h0l2.5.94h0a1.27,1.27,0,0,1-.9,2.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1163.12,904.52l-2.49-1a1.29,1.29,0,1,1,1-2.38h0l2.46,1h0a1.29,1.29,0,1,1-1,2.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1154.86,901l-2.46-1.1a1.3,1.3,0,0,1,1.07-2.38h0l2.43,1.1h0a1.31,1.31,0,0,1,.51,1.77,1.3,1.3,0,0,1-1.58.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1146.71,897.24l-2.42-1.19a1.31,1.31,0,1,1,1-2.41l.12.06h0l2.39,1.18h0a1.31,1.31,0,1,1-1.16,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1138.69,893.2l-2.38-1.26a1.32,1.32,0,0,1,1.24-2.34h0l2.36,1.26h0a1.32,1.32,0,0,1-1.19,2.36l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1130.81,888.91l-2.34-1.34a1.33,1.33,0,1,1,1.32-2.32h0l2.31,1.33h0a1.33,1.33,0,1,1-1.32,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1123.07,884.36l-2.3-1.42a1.35,1.35,0,1,1,1.42-2.24h0l2.27,1.41h0a1.34,1.34,0,1,1-1.41,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M1115.48,879.56l-2.25-1.49a1.36,1.36,0,0,1,1.5-2.27h0l2.23,1.49h0a1.36,1.36,0,0,1-1.5,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1108.05,874.51l-2.2-1.57a1.37,1.37,0,0,1,1.41-2.35l.18.13h0l2.17,1.56h0a1.36,1.36,0,1,1-1.58,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1100.79,869.21l-2.14-1.63a1.38,1.38,0,0,1,1.67-2.19h0l2.12,1.62h0a1.37,1.37,0,1,1-1.67,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1093.71,863.7l-2.08-1.7a1.39,1.39,0,0,1-.24-2l0,0a1.41,1.41,0,0,1,2-.23l0,0h0l2.06,1.69h0a1.39,1.39,0,0,1-1.58,2.29l-.18-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1086.83,857.92l-2-1.78a1.4,1.4,0,0,1,1.84-2.11h0l2,1.77h0A1.4,1.4,0,1,1,1087,858a1.07,1.07,0,0,1-.16-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M1080.19,851.92l-2-1.85a1.41,1.41,0,0,1,1.93-2.06h0l1.94,1.82h0a1.41,1.41,0,1,1-1.93,2.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1073.66,845.7l-1.9-1.91a1.42,1.42,0,0,1,2-2h0l1.87,1.89h0a1.42,1.42,0,0,1-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M1067.4,839.24l-1.83-2a1.45,1.45,0,1,1,2.1-2h0l1.8,2h0a1.43,1.43,0,0,1-2,2l-.05-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M1061.38,832.58l-1.76-2a1.45,1.45,0,0,1,2.19-1.89h0l1.74,2h0a1.45,1.45,0,0,1-.16,2A1.43,1.43,0,0,1,1061.38,832.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1055.6,825.7l-1.69-2.1a1.46,1.46,0,0,1,2.28-1.83h0l1.66,2.08h0a1.45,1.45,0,1,1-2.27,1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M1050.07,818.63l-1.61-2.16a1.47,1.47,0,0,1,2.3-1.83l.06.08h0l1.58,2.14h0a1.46,1.46,0,1,1-2.35,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M1044.8,811.35l-1.52-2.22a1.48,1.48,0,1,1,2.33-1.83l.1.15h0l1.5,2.2h0a1.48,1.48,0,0,1-2.44,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M1039.81,803.87l-1.44-2.28a1.49,1.49,0,0,1,2.52-1.59h0l1.42,2.25h0a1.49,1.49,0,1,1-2.42,1.74.86.86,0,0,1-.1-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M1035.11,796.21l-1.35-2.33a1.5,1.5,0,1,1,2.54-1.6l0,.09h0l1.33,2.31h0a1.5,1.5,0,0,1-2.49,1.68l-.1-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M1030.71,788.37l-1.26-2.38a1.51,1.51,0,1,1,2.64-1.46l0,.05h0l1.24,2.35h0a1.5,1.5,0,0,1-2.66,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1026.61,780.38l-1.17-2.43a1.52,1.52,0,1,1,2.74-1.32h0l1.15,2.39h0a1.52,1.52,0,0,1-2.74,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M1022.81,772.23l-1.08-2.47a1.53,1.53,0,0,1,2.81-1.23h0l1.06,2.44h0a1.53,1.53,0,1,1-2.81,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M1019.32,764l-1-2.51a1.55,1.55,0,0,1,2.88-1.13h0l1,2.48h0a1.54,1.54,0,1,1-2.87,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1016.19,755.55l-.9-2.54a1.56,1.56,0,0,1,2.94-1h0l.87,2.51h0a1.56,1.56,0,0,1-1,2h0A1.53,1.53,0,0,1,1016.19,755.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M1013.26,747l-.8-2.57a1.57,1.57,0,0,1,3-.93h0l.78,2.54h0a1.57,1.57,0,0,1-3,.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1010.7,738.42l-.71-2.6a1.58,1.58,0,0,1,2.86-1.35,1.82,1.82,0,0,1,.14.52h0l.69,2.57h0a1.57,1.57,0,0,1-3,.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M1008.44,729.7l-.62-2.62a1.59,1.59,0,0,1,3.1-.73h0l.6,2.6h0a1.59,1.59,0,1,1-3.09.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1006.49,721l-.52-2.64a1.59,1.59,0,0,1,1.24-1.87h0a1.61,1.61,0,0,1,1.88,1.26h0l.51,2.61h0a1.59,1.59,0,0,1-3.13.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1004.85,712.12l-.43-2.66a1.61,1.61,0,0,1,3.18-.52h0l.42,2.63h0a1.61,1.61,0,1,1-3.18.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M1003.53,703.23l-.34-2.68a1.62,1.62,0,0,1,3.22-.4h0l.33,2.64h0a1.62,1.62,0,0,1-3.21.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M1002.51,694.3l-.24-2.69a1.63,1.63,0,0,1,3.25-.3h0l.24,2.66h0a1.63,1.63,0,1,1-3.25.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M1001.81,685.33l-.15-2.69a1.64,1.64,0,0,1,3.28-.19h0l.14,2.66h0a1.64,1.64,0,0,1-3.26.36,1.09,1.09,0,0,1,0-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M1001.41,676.35v-2.7a1.66,1.66,0,0,1,3.31-.07h0v2.66h0a1.66,1.66,0,0,1-3.31.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M1001.34,667.35v-2.69a1.67,1.67,0,0,1,3.33-.26,1.13,1.13,0,0,1,0,.26h0v2.67h0a1.66,1.66,0,1,1-3.32-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M1001.57,658.36l.14-2.69a1.68,1.68,0,0,1,3.36,0,1.34,1.34,0,0,1,0,.2h0l-.14,2.66h0a1.68,1.68,0,0,1-3.36,0,1.34,1.34,0,0,1,0-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1002.13,649.38l.23-2.68a1.69,1.69,0,1,1,3.38,0,2,2,0,0,1,0,.23h0l-.23,2.66h0a1.69,1.69,0,0,1-3.38-.06,1.79,1.79,0,0,1,0-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M1003,640.43l.32-2.68a1.7,1.7,0,0,1,3.38.41h0l-.32,2.64h0a1.71,1.71,0,0,1-1.9,1.48A1.7,1.7,0,0,1,1003,640.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M1004.19,631.52l.42-2.67a1.71,1.71,0,0,1,3.38.53h0l-.42,2.63h0a1.71,1.71,0,1,1-3.38-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M1005.69,622.7l.51-2.65a1.72,1.72,0,0,1,3.38.65h0l-.51,2.61h0a1.72,1.72,0,0,1-3.37-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M1007.51,613.84l.61-2.63a1.73,1.73,0,1,1,3.38.78h0l-.6,2.59h0a1.73,1.73,0,0,1-3.37-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M1009.66,605.1l.7-2.6a1.75,1.75,0,0,1,3.37.91h0L1013,606h0a1.74,1.74,0,1,1-3.36-.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M1012.12,596.45l.8-2.58a1.76,1.76,0,0,1,3.36,1h0l-.8,2.54h0a1.76,1.76,0,0,1-3.35-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M1014.91,587.89l.89-2.54a1.77,1.77,0,0,1,3.34,1.17h0l-.89,2.51h0a1.76,1.76,0,1,1-3.32-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M1018,579.45l1-2.52a1.78,1.78,0,0,1,3.31,1.31h0l-1,2.47h0a1.77,1.77,0,1,1-3.3-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M1021.41,571.12l1.08-2.47a1.79,1.79,0,0,1,3.28,1.43h0l-1.07,2.44h0a1.79,1.79,0,0,1-3.27-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M1025.12,562.92l1.16-2.43a1.8,1.8,0,0,1,3.25,1.56h0l-1.16,2.4h0a1.79,1.79,0,1,1-3.23-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M1029.11,554.87l1.25-2.39a1.81,1.81,0,0,1,3.21,1.68h0l-1.24,2.35h0a1.81,1.81,0,0,1-3.2-1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M1033.39,547l1.33-2.35a1.83,1.83,0,1,1,3.3,1.58,1.71,1.71,0,0,1-.13.23h0l-1.32,2.31h0a1.83,1.83,0,0,1-2.49.67A1.8,1.8,0,0,1,1033.39,547Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M1037.94,539.2l1.41-2.3a1.84,1.84,0,0,1,2.53-.59,1.81,1.81,0,0,1,.6,2.5v0h0l-1.4,2.26h0a1.83,1.83,0,0,1-3.11-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M1042.75,531.6l1.5-2.24a1.84,1.84,0,0,1,3.07,2h0l-1.48,2.21h0a1.85,1.85,0,0,1-3.07-2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M1047.83,524.18l1.57-2.19a1.85,1.85,0,1,1,3.09,2l-.09.12h0l-1.55,2.15h0a1.85,1.85,0,0,1-3-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M1053.19,516.93l1.64-2.14a1.88,1.88,0,1,1,3,2.28h0l-1.63,2.1h0a1.88,1.88,0,0,1-3-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M1058.71,509.87l1.72-2.08a1.89,1.89,0,0,1,2.66-.08,1.87,1.87,0,0,1,.24,2.46h0l-1.69,2h0a1.88,1.88,0,0,1-2.89-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M1064.51,503l1.79-2a1.89,1.89,0,0,1,3,2.37l-.12.13h0l-1.77,2h0a1.88,1.88,0,1,1-2.83-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M1070.54,496.32l1.85-2a1.9,1.9,0,0,1,2.77,2.6h0l-1.83,1.93h0a1.9,1.9,0,1,1-2.93-2.42l.17-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M1076.79,489.85l1.92-1.9a1.9,1.9,0,1,1,2.68,2.7h0l-1.89,1.87h0a1.9,1.9,0,0,1-2.68-2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M1083.26,483.59l2-1.83a1.9,1.9,0,1,1,2.59,2.79h0l-2,1.81h0a1.91,1.91,0,1,1-2.74-2.65l.15-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1089.93,477.55l2-1.77a1.91,1.91,0,1,1,2.5,2.89h0l-2,1.74h0a1.91,1.91,0,0,1-2.5-2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M1096.8,471.7l2.1-1.7a1.92,1.92,0,1,1,2.41,3h0l-2.12,1.7h0a1.92,1.92,0,0,1-2.41-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1103.86,466.16l2.15-1.63a1.92,1.92,0,1,1,2.48,2.93,1.09,1.09,0,0,1-.17.13h0l-2.13,1.6h0a1.92,1.92,0,0,1-2.48-2.93l.17-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M1111.1,460.81l2.21-1.55a1.92,1.92,0,0,1,2.21,3.14h0l-2.17,1.53h0a1.92,1.92,0,1,1-2.24-3.11l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M1118.52,455.7l2.25-1.48a1.92,1.92,0,1,1,2.11,3.22h0l-2.23,1.46h0a1.92,1.92,0,0,1-2.1-3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M1126.1,450.87l2.31-1.4a1.93,1.93,0,0,1,2.09,3.25l-.09,0h0l-2.27,1.38h0a1.93,1.93,0,1,1-2.08-3.25l.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M1133.85,446.29l2.35-1.32a1.93,1.93,0,0,1,1.89,3.37h0l-2.32,1.3h0a1.93,1.93,0,1,1-1.89-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1141.74,442l2.45-1.28a1.93,1.93,0,1,1,1.78,3.43h0l-2.36,1.23h0a1.93,1.93,0,0,1-1.78-3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1149.79,437.94l2.44-1.16a1.94,1.94,0,1,1,1.66,3.51h0l-2.41,1.13h0a1.94,1.94,0,0,1-1.66-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M1158,434.18l2.48-1.07a1.94,1.94,0,1,1,1.54,3.57h0l-2.45,1h0a1.94,1.94,0,1,1-1.53-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M1166.27,430.7l2.52-1a1.95,1.95,0,0,1,1.42,3.63h0l-2.48,1h0a1.94,1.94,0,1,1-1.42-3.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M1174.7,427.54l2.54-.89a2,2,0,1,1,2.13,3.39,1.88,1.88,0,0,1-.83.29h0l-2.51.87h0a1.95,1.95,0,0,1-1.34-3.66l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M1183.19,424.7l2.58-.8a2,2,0,0,1,2.16,1.83,2,2,0,0,1-1,1.9h0l-2.54.8h0a2,2,0,1,1-1.2-3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M1191.84,422.08l2.6-.72a2,2,0,1,1,1,3.77h0l-2.56.71h0a2,2,0,1,1-1-3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M1200.54,419.79l2.62-.63a2,2,0,0,1,.92,3.81h0l-2.58.62h0a2,2,0,0,1-.91-3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M1209.31,417.79l2.64-.54a2,2,0,1,1,1.57,3.68,1.91,1.91,0,0,1-.78.16h0l-2.61.53h0a2,2,0,0,1-1.57-3.68,2.09,2.09,0,0,1,.78-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M1218.19,416.08l2.66-.45a2,2,0,1,1,1.42,3.74,2,2,0,0,1-.76.13h0l-2.62.44h0a2,2,0,1,1-1.36-3.76,2.06,2.06,0,0,1,.7-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M1227,414.7l2.67-.36a2,2,0,0,1,1.24,3.81,2,2,0,0,1-.7.09h0l-2.63.37h0a2,2,0,0,1-.54-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1235.94,413.54l2.69-.28a2,2,0,1,1,1.09,3.85,2,2,0,0,1-.68.07h0l-2.65.27h0a2,2,0,0,1-.41-3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M1244.9,412.7l2.69-.19a2,2,0,1,1,.92,3.9,2.23,2.23,0,0,1-.63,0h0l-2.65.19h0a2,2,0,0,1-.28-3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1253.87,412.15l2.7-.11a2,2,0,0,1,.16,4h0l-2.66.1h0a2,2,0,0,1-.16-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M1262.86,411.89h2.7a2,2,0,0,1,0,4h-2.66a2,2,0,0,1,0-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M1271.86,411.92l2.7.06a2,2,0,1,1-.1,4h0l-2.66-.07h0a2,2,0,0,1,.1-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M1280.85,412.23l2.69.15a2,2,0,0,1-.22,4h0l-2.65-.14h0a2,2,0,1,1,.22-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M1289.82,412.82l2.69.24a2,2,0,1,1-.34,4h0l-2.65-.23h0a2,2,0,0,1,.34-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M1298.78,413.7l2.68.32a2,2,0,1,1-.47,4h0l-2.65-.32h0a2,2,0,0,1,.47-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M1307.7,414.86l2.67.41a2,2,0,0,1-.6,4h0l-2.63-.4h0a2,2,0,1,1,.6-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M1316.58,416.31l2.66.49a2,2,0,1,1-.73,3.94h0l-2.61-.48h0a2,2,0,1,1,.72-3.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M1325.42,418l2.63.58a2,2,0,0,1-.85,3.93h0l-2.6-.57h0a2,2,0,0,1,.86-3.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M1334.19,420l2.62.66a2,2,0,0,1-1,3.9h0l-2.58-.65h0a2,2,0,1,1,1-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M1342.89,422.33l2.6.74a2,2,0,1,1-1.11,3.88h0l-2.56-.73h0a2,2,0,1,1,1.11-3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M1351.52,424.89l2.57.83a2,2,0,1,1-1.24,3.85h0l-2.53-.81h0a2,2,0,0,1,1.24-3.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M1360.06,427.7l2.54.9a2,2,0,1,1-1.36,3.82h0l-2.51-.9h0a2,2,0,0,1,1.37-3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M1368.5,430.86l2.51,1a2,2,0,0,1-1.49,3.77h0l-2.47-1h0a2,2,0,1,1,1.49-3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M1376.83,434.26l2.48,1.07a2,2,0,1,1-1.62,3.73h0l-2.44-1.06h0a2,2,0,1,1,1.62-3.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M1385.05,437.93l2.44,1.15a2,2,0,1,1-1.74,3.68h0l-2.41-1.14h0a2,2,0,1,1,1.74-3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M1393.19,441.85l2.41,1.22a2,2,0,1,1-1.84,3.63h0l-2.38-1.21h0a2,2,0,0,1,1.84-3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M1401.12,446l2.38,1.27a2,2,0,1,1-1.93,3.6h0l-2.35-1.26h0a2,2,0,0,1,1.93-3.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M1409,450.26l2.35,1.32a2,2,0,1,1-2,3.57h0l-2.33-1.31h0a2,2,0,0,1,2-3.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M1416.8,454.7l2.32,1.35a2,2,0,1,1-2,3.55h0l-2.31-1.34h0a2.05,2.05,0,0,1,2.06-3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M1424.53,459.21l2.31,1.37a2.05,2.05,0,1,1-2.1,3.53h0l-2.29-1.37h0a2.05,2.05,0,0,1,2.1-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M1432.19,463.8l2.3,1.39a2.06,2.06,0,0,1-2.13,3.52h0l-2.29-1.39a2.05,2.05,0,1,1,2.12-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M1439.86,468.43l2.29,1.39a2.06,2.06,0,0,1-2.14,3.52h0l-2.29-1.39a2.06,2.06,0,1,1,2.09-3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M1447.49,473.06l2.3,1.39a2.06,2.06,0,1,1-2.14,3.53h0l-2.29-1.39a2.06,2.06,0,1,1,2.13-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M1455.19,477.7l2.29,1.37h0a2.07,2.07,0,0,1-2.12,3.55h0l-2.3-1.38a2.06,2.06,0,1,1,2.12-3.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M1462.8,482.22l2.31,1.35h0a2.08,2.08,0,0,1-2.1,3.58h0l-2.32-1.36a2.07,2.07,0,0,1,2.1-3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M1470.51,486.7l2.32,1.32h0a2.07,2.07,0,0,1-1.71,3.77,1.64,1.64,0,0,1-.29-.16h0l-2.34-1.33a2.07,2.07,0,1,1,1.63-3.8,1.65,1.65,0,0,1,.37.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M1478.28,491l2.34,1.27h0a2.08,2.08,0,1,1-2,3.65h0l-2.37-1.29a2.08,2.08,0,0,1,2-3.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M1486.12,495.2l2.37,1.22h0a2.08,2.08,0,1,1-1.91,3.7h0l-2.4-1.24a2.08,2.08,0,0,1,1.91-3.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M1494.06,499.19l2.4,1.15h0a2.09,2.09,0,0,1-1.59,3.87l-.22-.11h0l-2.43-1.17a2.09,2.09,0,0,1,1.81-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M1502.09,503l2.43,1.08h0a2.09,2.09,0,0,1-1.69,3.82h0l-2.46-1.1a2.09,2.09,0,0,1,1.69-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M1510.19,506.44l2.47,1h0a2.1,2.1,0,0,1-1.56,3.89h0l-2.51-1a2.09,2.09,0,1,1,1.55-3.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M1518.49,509.63l2.5.9h0a2.09,2.09,0,1,1-1.41,3.94h0l-2.55-.91a2.09,2.09,0,0,1,1.42-3.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M1526.86,512.48l2.53.79h0a2.1,2.1,0,0,1-1.24,4h0l-2.59-.8a2.1,2.1,0,1,1,1-4.08l.26.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M1535.34,515l2.57.66h0a2.1,2.1,0,0,1-1,4.07h0l-2.62-.68a2.1,2.1,0,1,1,.74-4.13,1.22,1.22,0,0,1,.26.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M1543.93,517l2.59.53h0a2.11,2.11,0,0,1-.84,4.13h0l-2.65-.55a2.1,2.1,0,0,1,.84-4.12h.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M1552.61,518.6l2.61.39h0a2.11,2.11,0,1,1-.63,4.18h0l-2.68-.41a2.11,2.11,0,0,1,.44-4.2l.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M1561.35,519.7l2.63.25h0a2.11,2.11,0,1,1-.4,4.21h0l-2.7-.26a2.11,2.11,0,0,1,.4-4.21h.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M1570.19,520.39l2.64.1h0a2.12,2.12,0,0,1-.16,4.23h0l-2.72-.1a2.12,2.12,0,0,1,.16-4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M1578.94,520.54l2.64-.06h0a2.12,2.12,0,0,1,.1,4.24h0l-2.72.06a2.12,2.12,0,0,1-.09-4.24h.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M1587.74,520.15l2.63-.23h0a2.12,2.12,0,1,1,.36,4.23h0l-2.71.23a2.12,2.12,0,0,1-.36-4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M1596.48,519.2l2.6-.4h0a2.13,2.13,0,0,1,.68,4.21h0l-2.69.41a2.13,2.13,0,0,1-.64-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M1605.12,517.7l2.57-.58h0a2.13,2.13,0,1,1,.94,4.16h0l-2.66.6a2.13,2.13,0,0,1-.93-4.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M1613.63,515.52l2.52-.77h0a2.14,2.14,0,0,1,1.46,4l-.22.06h0l-2.61.79a2.14,2.14,0,0,1-1.23-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M1622,512.75l2.44-1h0a2.15,2.15,0,0,1,1.56,4h0l-2.55,1a2.14,2.14,0,0,1-1.55-4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M1630,509.33l2.36-1.15h0a2.14,2.14,0,1,1,1.88,3.85h0l-2.46,1.2a2.14,2.14,0,0,1-1.87-3.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M1637.77,505.27l2.27-1.33h0a2.14,2.14,0,1,1,2.18,3.69h0l-2.35,1.38a2.14,2.14,0,0,1-2.18-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M1645.19,500.61l2.15-1.52h0a2.15,2.15,0,0,1,2.6,3.43l-.12.08h0l-2.23,1.58a2.15,2.15,0,0,1-2.48-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M1652.19,495.35l2-1.69h0A2.15,2.15,0,1,1,1657,497h0l-2.09,1.75a2.15,2.15,0,0,1-2.77-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M1658.72,489.53l1.86-1.85h0a2.16,2.16,0,0,1,3.39,2.68,2,2,0,0,1-.39.38h0l-1.94,1.93a2.16,2.16,0,0,1-3-3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M1664.72,483.17l1.68-2h0a2.16,2.16,0,0,1,3.31,2.78h0l-1.77,2.1a2.16,2.16,0,1,1-3.43-2.62,1.83,1.83,0,0,1,.13-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M1670.12,476.31l1.48-2.15v-.06a2.17,2.17,0,0,1,3.56,2.47h0l-1.56,2.25a2.16,2.16,0,0,1-3.56-2.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M1674.83,469l1.27-2.28v-.06a2.16,2.16,0,0,1,3.78,2.11h0l-1.33,2.4a2.17,2.17,0,1,1-3.86-2,.75.75,0,0,0,.07-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M1678.8,461.22l1-2.4v-.07a2.18,2.18,0,0,1,4,1.72h0l-1.08,2.52a2.18,2.18,0,1,1-4-1.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M1681.93,453.1l.76-2.49v-.07a2.17,2.17,0,1,1,4.15,1.27h0l-.81,2.64a2.17,2.17,0,1,1-4.15-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M1684.13,444.7l.48-2.57v-.07a2.18,2.18,0,0,1,4.33.54,2.21,2.21,0,0,1,0,.25h0l-.5,2.71a2.18,2.18,0,0,1-4.28-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M1685.37,436.11l.19-2.6v-.08a2.19,2.19,0,0,1,4.36.32h0l-.2,2.74a2.18,2.18,0,1,1-4.35-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M1685.66,427.42l-.09-2.61v-.11a2.19,2.19,0,0,1,4.37-.16h0l.1,2.75a2.19,2.19,0,0,1-4.37.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M1685,418.75l-.38-2.58v-.07a2.18,2.18,0,0,1,4.32-.63h0l.39,2.72a2.18,2.18,0,0,1-4.31.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M1683.44,410.2l-.66-2.52v-.08a2.17,2.17,0,0,1,4.21-1.09l.69,2.66a2.18,2.18,0,1,1-4.14,1.37,2.68,2.68,0,0,1-.07-.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M1680.93,401.88l-.93-2.43v-.07a2.17,2.17,0,0,1,4.06-1.56l1,2.57A2.17,2.17,0,1,1,1681,402h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M1677.49,393.92l-1.21-2.3v-.07a2.17,2.17,0,0,1,3.7-2.26,1.3,1.3,0,0,1,.14.26l1.29,2.44a2.17,2.17,0,1,1-3.7,2.27c0-.09-.1-.18-.14-.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M1673.13,386.44l-1.49-2.13v-.07a2.17,2.17,0,0,1,3.5-2.56l.06.08,1.58,2.26a2.17,2.17,0,1,1-3.44,2.64l-.11-.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M1667.86,379.58l-1.75-1.91-.06-.06a2.17,2.17,0,0,1,3.19-2.93l1.87,2a2.17,2.17,0,0,1-3,3.13,1.8,1.8,0,0,1-.19-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M1661.73,373.51l-2-1.65-.07-.06a2.16,2.16,0,0,1,2.75-3.33l2.14,1.76a2.16,2.16,0,1,1-2.75,3.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M1654.81,368.4l-2.22-1.33-.08-.05a2.15,2.15,0,0,1,2.21-3.7l2.39,1.42a2.16,2.16,0,1,1-2.11,3.77l-.1-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M1647.19,364.38l-2.39-1h-.09a2.16,2.16,0,0,1,1.65-4l2.56,1.06a2.16,2.16,0,1,1-1.64,4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M1639.07,361.47l-2.5-.65h-.09a2.15,2.15,0,0,1,1.08-4.17h0l2.68.7a2.15,2.15,0,0,1-1,4.2l-.13,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M1630.62,359.7l-2.58-.31H1628a2.15,2.15,0,0,1,.52-4.27l2.74.33a2.15,2.15,0,0,1-.51,4.27h-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M1622,359h-2.68a2.13,2.13,0,0,1-2.17-2.09v0a2.16,2.16,0,0,1,2.12-2.17H1622a2.15,2.15,0,0,1,.34,4.29H1622Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M1613.37,359.54l-2.56.38h-.09a2.14,2.14,0,1,1-.62-4.24h0l2.74-.4a2.14,2.14,0,0,1,.62,4.24h-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M1604.91,361.2l-2.48.74h-.09a2.14,2.14,0,0,1-1.41-4l.2-.06,2.66-.79a2.14,2.14,0,1,1,1.21,4.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M1596.79,364.06l-2.34,1.1h-.09a2.14,2.14,0,1,1-2-3.76l.23-.11,2.52-1.18a2.14,2.14,0,1,1,2,3.76l-.23.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M1589.19,368.13l-2.12,1.45-.09.06a2.13,2.13,0,0,1-2.41-3.52h0l2.3-1.57a2.13,2.13,0,0,1,2.41,3.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M1582.47,373.37l-1.84,1.79-.08.08a2.14,2.14,0,0,1-3-3.05l2-1.95a2.13,2.13,0,0,1,3,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M1576.76,379.7l-1.46,2.1-.08.1a2.12,2.12,0,1,1-3.48-2.43h0l1.6-2.3a2.13,2.13,0,1,1,3.63,2.23,1.43,1.43,0,0,1-.14.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M1572.36,387l-1.06,2.34v.1a2.12,2.12,0,1,1-3.87-1.74l1.14-2.55a2.12,2.12,0,0,1,3.87,1.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M1569.33,395l-.64,2.5v.1a2.12,2.12,0,1,1-4.11-1.06l.7-2.7a2.12,2.12,0,0,1,4.1,1.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M1567.66,403.42l-.24,2.57v.1a2.12,2.12,0,0,1-4.23-.39l.25-2.77a2.12,2.12,0,0,1,4.22.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M1567.33,412l.16,2.57v.1a2.11,2.11,0,0,1-4.22.26h0l-.17-2.77a2.11,2.11,0,1,1,4.22-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M1568.31,420.56l.55,2.52v.1a2.11,2.11,0,0,1-4.12.9l-.59-2.71a2.11,2.11,0,0,1,4.1-1,.19.19,0,0,1,0,.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M1570.61,428.84l1,2.39v.1a2.1,2.1,0,0,1-3.91,1.55l-1-2.59a2.11,2.11,0,0,1,3.85-1.73,1.34,1.34,0,0,1,.07.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M1574.19,436.59l1.34,2.19.06.1a2.1,2.1,0,0,1-3.58,2.2l-1.42-2.38a2.1,2.1,0,0,1,3.58-2.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M1579.19,443.54l1.73,1.87.08.1a2.1,2.1,0,0,1-3.08,2.85l-1.91-2.07a2.1,2.1,0,1,1,3.09-2.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M1585.35,449.34l2.08,1.47.11.08a2.09,2.09,0,0,1-2.42,3.42h0l-2.3-1.62a2.1,2.1,0,0,1,2.42-3.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1551,737c.17-.39.34-.78.53-1.17,8.85-18.68,23.5-22.54,36.41-16.42s19.2,19.91,10.35,38.59l-.24.48C1589.38,752,1572.66,741.41,1551,737Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1598.08,758.48c-9,18.48-29.36,34.64-42.16,28.57s-13.19-31.46-4.89-50C1572.66,741.41,1589.38,752,1598.08,758.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1575.53,727a167.89,167.89,0,0,0,11.32-24.65,75.32,75.32,0,0,0,3.51-13.22,33.48,33.48,0,0,0,.41-7,15.09,15.09,0,0,0-1.89-7,10.46,10.46,0,0,0-5.76-4.63,17.77,17.77,0,0,0-7.17-.79,11.45,11.45,0,0,0-7,2.67,9.93,9.93,0,0,0-3,7,17.75,17.75,0,0,0,1.17,7.18,17.23,17.23,0,0,0,3.82,6.27,6.64,6.64,0,0,0,3.75,2.06,4.12,4.12,0,0,0,2.55-.51,5.78,5.78,0,0,0,1.74-1.6,17,17,0,0,0,2.21-7.12,1.6,1.6,0,0,0-1.33-1.83h0a1.62,1.62,0,0,0-1.84,1.34h0v.12a14.64,14.64,0,0,1-1.58,5.72c-.5.67-.88.9-1.38.86a3.89,3.89,0,0,1-2-1.19,14.33,14.33,0,0,1-3.22-5.13,15.18,15.18,0,0,1-1.1-6,7.22,7.22,0,0,1,2.09-5.16,8.94,8.94,0,0,1,5.38-2.09c4.18-.43,8.71.56,10.75,4.09a13,13,0,0,1,1.69,5.93,32.93,32.93,0,0,1-.28,6.51,74.39,74.39,0,0,1-3.2,12.92,166.82,166.82,0,0,1-10.78,24.58h0a.69.69,0,0,0,.34.9.68.68,0,0,0,.85-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1589.85,733.7a167.57,167.57,0,0,1,12.2-23.91,75.39,75.39,0,0,1,8-10.65,33.44,33.44,0,0,1,4.87-4.34,13,13,0,0,1,5.66-2.45c4-.65,7.65,2.23,10,5.73a8.94,8.94,0,0,1,1.78,5.5,7.21,7.21,0,0,1-2.66,4.88,15,15,0,0,1-5.37,3,14.39,14.39,0,0,1-6,.77,3.91,3.91,0,0,1-2.2-.82c-.35-.36-.41-.8-.21-1.61a14.63,14.63,0,0,1,3.43-4.84h.05a1.61,1.61,0,1,0-2.32-2.24h0A17.59,17.59,0,0,0,1613,709a6.06,6.06,0,0,0-.14,2.36,4.24,4.24,0,0,0,1.22,2.3,6.64,6.64,0,0,0,4,1.59,17,17,0,0,0,7.28-1,17.54,17.54,0,0,0,6.3-3.64,9.89,9.89,0,0,0,3.44-6.76,11.38,11.38,0,0,0-2.33-7.08,17.91,17.91,0,0,0-5.15-5,10.48,10.48,0,0,0-7.24-1.53,15.32,15.32,0,0,0-6.58,2.94,33.76,33.76,0,0,0-5.12,4.73,76.35,76.35,0,0,0-8,11.07,168.6,168.6,0,0,0-11.91,24.38.69.69,0,0,0,.48.84.67.67,0,0,0,.77-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1578.9,742.55s-7.58,68.31,19.16,72.07S1622.71,779.19,1578.9,742.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1578.9,742.55s-48.08,49.11-67.92,30.8S1522.8,731.83,1578.9,742.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1574.82,745s-64.6,23.47-74.56-1.62S1528.88,711.07,1574.82,745Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1581.51,748.18S1604.24,813,1630,804.86,1636.86,762.25,1581.51,748.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1597.68,810.32a1.65,1.65,0,0,0,.69.15c6.09,0,10.21-1.9,12.24-5.7,6-11.16-9.71-34.74-10.38-35.74a1.61,1.61,0,0,0-2.68,1.79c4.27,6.36,14.42,24.58,10.22,32.43-1.43,2.67-4.59,4-9.39,4a1.61,1.61,0,0,0-.7,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1577.62,745.24s-22.8-35.37-36.2-41.72c-14.44-6.83-36.45-.45-47.26,3.48a2.32,2.32,0,0,0,.17,4.41C1519,718.7,1547.59,731,1577.62,745.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1575.29,744.13s41.82-4.74,55.21,1.61c14.43,6.85,23.43,27.92,27.23,38.78a2.32,2.32,0,0,1-3.52,2.66C1633,772.7,1605.34,758.36,1575.29,744.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1649.09,777.05a1.57,1.57,0,0,0,1.34,0,1.61,1.61,0,0,0,.82-2.12c-.58-1.31-14.44-32.1-37.48-30a1.61,1.61,0,0,0,.08,3.22l.21,0c20.76-1.88,34.11,27.81,34.25,28.11A1.54,1.54,0,0,0,1649.09,777.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M944.19,788.51,621,785.61a11.37,11.37,0,0,0-11.46,11.26V797L611,1045a11.36,11.36,0,0,0,11.41,11.3h.28c58.43-1.74,317.84-9.43,329.29-9s5.17-198.73,3.48-247.88A11.35,11.35,0,0,0,944.19,788.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M622.33,1046.75a1.79,1.79,0,0,1-1.8-1.78h0l-1.42-248a1.77,1.77,0,0,1,.53-1.28,1.83,1.83,0,0,1,1.29-.53L944.09,798a1.8,1.8,0,0,1,1.79,1.74c4.17,121.5,4.26,214.77.21,237.61l-.07.4h-.41c-42.83.6-276.75,7.54-323.23,8.93Zm-1.41-250.59a.82.82,0,0,0-.82.81l1.42,248a.8.8,0,0,0,.79.81h0v0c46.32-1.38,278.93-8.29,322.84-8.93,4-23.45,3.86-116.26-.29-237a.81.81,0,0,0-.81-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M905.19,1015.07H693.34a8.52,8.52,0,0,1-8.53-8.51,8.63,8.63,0,0,1,1.18-4.34L769.85,859.7a8.53,8.53,0,0,1,15.11.78l40.49,88.73a8.52,8.52,0,0,0,11.3,4.22A8.66,8.66,0,0,0,839,952l16.38-15a8.55,8.55,0,0,1,12.07.54,8.44,8.44,0,0,1,.7.88l44.07,63.32a8.52,8.52,0,0,1-7,13.37Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-232",
    cx: 696.22,
    cy: 855.34,
    r: 30.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M448.19,518.29a1.75,1.75,0,0,1-2.48-.15,1.78,1.78,0,0,1-.44-1c-.21-2.34-.37-4.72-.48-7.06a1.75,1.75,0,1,1,3.5-.18c.12,2.3.28,4.64.48,6.94A1.79,1.79,0,0,1,448.19,518.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M742.12,354.3a1.75,1.75,0,0,1-2.22.1c-3.81-2.83-7.78-5.55-11.79-8.08a1.76,1.76,0,1,1,1.86-3c4.1,2.58,8.14,5.35,12,8.24a1.75,1.75,0,0,1,.35,2.45h0A1.15,1.15,0,0,1,742.12,354.3ZM709.62,335a1.74,1.74,0,0,1-1.92.29c-4.29-2-8.73-3.83-13.2-5.48a1.76,1.76,0,0,1,1.22-3.3c4.55,1.69,9.08,3.57,13.46,5.6a1.75,1.75,0,0,1,.85,2.33h0A1.43,1.43,0,0,1,709.62,335ZM673.84,322.7a1.73,1.73,0,0,1-1.57.41c-4.64-1.09-9.36-2-14-2.72a1.76,1.76,0,0,1,.53-3.47c4.77.73,9.59,1.66,14.31,2.77a1.76,1.76,0,0,1,1.3,2.11h0A1.69,1.69,0,0,1,673.84,322.7ZM448.08,487.85a1.74,1.74,0,0,1-1.32.45,1.76,1.76,0,0,1-1.61-1.89c.39-4.82,1-9.68,1.73-14.47a1.76,1.76,0,0,1,3.51.34,1.55,1.55,0,0,1,0,.21c-.75,4.7-1.32,9.47-1.7,14.19A1.7,1.7,0,0,1,448.08,487.85Zm188.25-170a1.76,1.76,0,0,1-1.22.45c-4.74-.12-9.54-.05-14.28.21a1.75,1.75,0,0,1-.19-3.5c4.83-.27,9.73-.34,14.56-.22a1.75,1.75,0,0,1,1.71,1.79h0a1.69,1.69,0,0,1-.58,1.28ZM454.93,450.64a1.74,1.74,0,0,1-2.47-.1,1.77,1.77,0,0,1-.39-1.69c1.35-4.66,2.91-9.3,4.61-13.82a1.75,1.75,0,0,1,3.28,1.24c-1.67,4.43-3.19,9-4.52,13.56A1.78,1.78,0,0,1,454.93,450.64ZM598.64,320.86a1.63,1.63,0,0,1-.85.42c-4.65.86-9.34,1.91-13.94,3.14A1.75,1.75,0,0,1,583,321c4.68-1.25,9.46-2.33,14.2-3.2a1.75,1.75,0,0,1,1.49,3ZM469.19,415.59a1.71,1.71,0,0,1-2,.25,1.76,1.76,0,0,1-.73-2.37c2.28-4.28,4.75-8.51,7.34-12.59a1.77,1.77,0,0,1,3,1.89c-2.54,4-5,8.15-7.19,12.34A1.62,1.62,0,0,1,469.19,415.59ZM562.4,331.5a1.69,1.69,0,0,1-.51.32c-4.39,1.79-8.77,3.78-13,5.91a1.75,1.75,0,0,1-1.58-3.13c4.32-2.18,8.79-4.2,13.26-6a1.76,1.76,0,0,1,1.84,2.93ZM529,349.29a1.56,1.56,0,0,1-.2.16c-3.93,2.64-7.81,5.48-11.54,8.43a1.76,1.76,0,0,1-2.47-.29,1.8,1.8,0,0,1,.29-2.47c3.8-3,7.76-5.89,11.77-8.59a1.75,1.75,0,0,1,2.15,2.76ZM490.25,384.2a1.75,1.75,0,1,1-2.52-2.43c3.1-3.71,6.38-7.35,9.76-10.81a1.77,1.77,0,0,1,2.49,0,1.75,1.75,0,0,1,0,2.48h0c-3.31,3.39-6.54,7-9.58,10.6A.75.75,0,0,1,490.25,384.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M765,374.49a1.75,1.75,0,0,1-2.45-.09c-1.59-1.66-3.24-3.31-4.9-4.92a1.75,1.75,0,0,1,0-2.46l0,0a1.78,1.78,0,0,1,2.48,0c1.69,1.63,3.37,3.32,5,5a1.77,1.77,0,0,1,0,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M816.34,508.91a1.72,1.72,0,0,1-1.24.45,1.76,1.76,0,0,1-1.69-1.82c.09-2.32.13-4.66.12-7a1.76,1.76,0,0,1,3.51,0c0,2.34,0,4.72-.12,7.09A1.78,1.78,0,0,1,816.34,508.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M755.67,639.13l-1.18,1.06a1.76,1.76,0,0,1-2.34-2.62h0l1.16-1c3.08-2.78,6.11-5.71,9-8.7a1.78,1.78,0,0,1,2.48,0,1.74,1.74,0,0,1,0,2.46l0,0C761.9,633.32,758.81,636.3,755.67,639.13Zm-19.34,15.25a1.33,1.33,0,0,1-.19.14c-3.92,2.69-8,5.26-12.12,7.65a1.76,1.76,0,0,1-1.76-3c4-2.33,8-4.86,11.9-7.49a1.76,1.76,0,0,1,2.44.44h0a1.76,1.76,0,0,1-.27,2.3Zm43.38-41.58a1.76,1.76,0,0,1-2.58-2.36c2.8-3.74,5.48-7.64,8-11.57a1.77,1.77,0,0,1,3,1.87c-2.55,4-5.29,8-8.14,11.81a2.18,2.18,0,0,1-.28.25Zm-76,59.43a2,2,0,0,1-.5.32c-4.39,1.85-8.9,3.56-13.4,5.06a1.76,1.76,0,0,1-1.12-3.33c4.42-1.47,8.85-3.15,13.16-5a1.76,1.76,0,0,1,2.29,1,1.74,1.74,0,0,1-.43,2Zm95.19-91.34a1.76,1.76,0,0,1-2.77-2c2-4.21,3.82-8.57,5.48-13a1.76,1.76,0,1,1,3.31,1.19.14.14,0,0,1,0,.06c-1.7,4.47-3.58,8.91-5.59,13.2a1.73,1.73,0,0,1-.44.6ZM668.11,683.2a1.68,1.68,0,0,1-.82.41c-4.66.94-9.42,1.7-14.15,2.27a1.75,1.75,0,1,1-.42-3.48c4.63-.56,9.3-1.31,13.88-2.23a1.76,1.76,0,0,1,1.51,3ZM811.19,545.77a1.75,1.75,0,0,1-2.88-1.71c1.1-4.54,2-9.18,2.8-13.79a1.75,1.75,0,0,1,3.46.57c-.76,4.69-1.72,9.42-2.85,14A1.68,1.68,0,0,1,811.19,545.77Zm-180.14,141a1.66,1.66,0,0,1-1.18.45c-4.75,0-9.57-.24-14.32-.63a1.76,1.76,0,0,1,.29-3.5c4.67.39,9.39.6,14,.62a1.75,1.75,0,0,1,1.74,1.76h0a1.7,1.7,0,0,1-.55,1.29Zm-37-4a1.74,1.74,0,0,1-1.54.41c-3.67-.77-7.36-1.67-11-2.66-1-.27-2-.54-2.92-.83a1.76,1.76,0,0,1,1-3.37c1,.28,1.91.55,2.87.81,3.56,1,7.19,1.86,10.78,2.62a1.76,1.76,0,0,1,1.36,2.08,1.73,1.73,0,0,1-.51,1ZM558.57,671.5a1.72,1.72,0,0,1-1.87.31c-4.37-1.89-8.72-4-12.93-6.19a1.76,1.76,0,1,1,1.41-3.22,1.51,1.51,0,0,1,.22.11c4.13,2.18,8.4,4.22,12.69,6.07a1.75,1.75,0,0,1,.92,2.3h0a1.63,1.63,0,0,1-.39.64Zm-32.5-18.15a1.73,1.73,0,0,1-2.18.13c-3.89-2.73-7.73-5.65-11.41-8.67a1.75,1.75,0,0,1,2.23-2.71c3.61,3,7.38,5.83,11.2,8.51a1.76,1.76,0,0,1,.43,2.44,1.5,1.5,0,0,1-.23.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M497.91,629a1.76,1.76,0,0,1-2.45-.1c-1.61-1.7-3.21-3.47-4.76-5.25a1.82,1.82,0,0,1,.16-2.47,1.76,1.76,0,0,1,2.48.16c1.53,1.75,3.1,3.48,4.67,5.15A1.75,1.75,0,0,1,498,629h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M513.29,580.13a2.21,2.21,0,0,0,2.29,1.16l26.61-4.13a116.94,116.94,0,0,0,29.26,24.28l.87,26.91a2.21,2.21,0,0,0,1.56,2l30.88,9.54a2.2,2.2,0,0,0,2.44-.81l15.9-21.73A117.18,117.18,0,0,0,661,613.81l19.66,18.42a2.23,2.23,0,0,0,2.55.34l28.58-15.09a2.2,2.2,0,0,0,1.15-2.3l-4.1-26.58a117.37,117.37,0,0,0,24.28-29.26l26.91-.88a2.19,2.19,0,0,0,2-1.56L771.52,526a2.2,2.2,0,0,0-.81-2.44L749,507.7a117.55,117.55,0,0,0-3.55-37.86l18.42-19.66a2.2,2.2,0,0,0,.34-2.55l-15-28.58a2.23,2.23,0,0,0-2.29-1.16L720.19,422A117.21,117.21,0,0,0,691,397.7l-.87-26.91a2.19,2.19,0,0,0-1.56-2l-30.88-9.54a2.22,2.22,0,0,0-2.44.81l-15.9,21.73a117.48,117.48,0,0,0-37.85,3.54L581.8,366.91a2.23,2.23,0,0,0-2.55-.34L550.67,381.7a2.22,2.22,0,0,0-1.15,2.3l4.12,26.62a118.16,118.16,0,0,0-24.28,29.26l-26.91.88a2.21,2.21,0,0,0-2,1.56l-9.54,30.87a2.21,2.21,0,0,0,.81,2.44l21.73,15.9A117.52,117.52,0,0,0,517,529.39l-18.42,19.66a2.2,2.2,0,0,0-.34,2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M652.19,522.85h0a31.32,31.32,0,1,1,10.32-21.64,31.31,31.31,0,0,1-10.32,21.64Zm-38.44-42.61A26.06,26.06,0,0,0,648.65,519h0a26.06,26.06,0,1,0-34.9-38.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M685.88,559a80.66,80.66,0,0,1-93.69,10.5l2.58-4.59A75.43,75.43,0,0,0,692,544.42l.11-.14.1-.14a75.35,75.35,0,1,0-133.7-27l-5.12,1.25a80.66,80.66,0,0,1,138.1-73.27A81.91,81.91,0,0,1,703,461.62,80.55,80.55,0,0,1,685.84,559Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M810.85,550.44a1.43,1.43,0,0,1-.52-.69,1.36,1.36,0,0,1,.85-1.72h0c1.74-.59,3.53-1.13,5.3-1.6a1.36,1.36,0,1,1,.7,2.63c-1.72.46-3.44,1-5.13,1.55A1.37,1.37,0,0,1,810.85,550.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M919.66,654.83a1.37,1.37,0,0,1-.54-1.5,82.63,82.63,0,0,0,2.4-11,1.36,1.36,0,1,1,2.7.4h0a86,86,0,0,1-2.48,11.33,1.37,1.37,0,0,1-1.69.93A1.34,1.34,0,0,1,919.66,654.83Zm3.19-29.65a1.36,1.36,0,0,1-.6-1,81.79,81.79,0,0,0-1.51-11.13,1.37,1.37,0,0,1,2.65-.72l0,.18A88.87,88.87,0,0,1,925,624a1.36,1.36,0,0,1-1.26,1.45h0A1.34,1.34,0,0,1,922.85,625.18Zm-88.46-79.1a1.37,1.37,0,0,1,.71-2.49h0c2.06-.09,4.15-.1,6.22,0,1.79,0,3.6.16,5.38.32a1.37,1.37,0,0,1-.25,2.72c-1.72-.16-3.47-.26-5.21-.31-2-.06-4-.05-6,0a1.3,1.3,0,0,1-.85-.24Zm81.23,50.16a1.28,1.28,0,0,1-.47-.56,84,84,0,0,0-5.28-9.91,1.37,1.37,0,0,1,2.2-1.63.76.76,0,0,1,.12.19,88.73,88.73,0,0,1,5.45,10.23,1.37,1.37,0,0,1-2,1.68ZM864,550a1.34,1.34,0,0,1-.53-1.54,1.38,1.38,0,0,1,1.71-.88,87,87,0,0,1,10.79,4.27,1.36,1.36,0,1,1-1.18,2.46,83,83,0,0,0-10.44-4.13A1.29,1.29,0,0,1,864,550Zm34.87,21.57a1.12,1.12,0,0,1-.21-.17,83.89,83.89,0,0,0-8.37-7.5A1.36,1.36,0,0,1,890,562h0a1.38,1.38,0,0,1,1.91-.23,86.82,86.82,0,0,1,8.64,7.73,1.36,1.36,0,0,1-1.74,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M909.75,676.7a1.37,1.37,0,0,1-.39-1.86c1-1.51,1.89-3.06,2.74-4.62a1.37,1.37,0,0,1,1.86-.53,1.32,1.32,0,0,1,.57,1.78.25.25,0,0,1,0,.07c-.88,1.61-1.83,3.21-2.83,4.77a1.36,1.36,0,0,1-1.88.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M852.94,714.7a1.36,1.36,0,0,1-.33-1.91,1.39,1.39,0,0,1,.87-.56c1.75-.31,3.52-.68,5.25-1.1a1.34,1.34,0,0,1,1.63,1v0a1.36,1.36,0,0,1-1,1.65h0c-1.78.43-3.61.82-5.42,1.14A1.4,1.4,0,0,1,852.94,714.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M796,704.93a1.36,1.36,0,0,1,1.45-2.31,84.35,84.35,0,0,0,9.94,4.83,1.36,1.36,0,1,1-.8,2.6l-.2-.08a83.78,83.78,0,0,1-10.26-5Zm-14.77-10.66-.14-.12a85.71,85.71,0,0,1-8-8.17,1.36,1.36,0,1,1,2.07-1.77h0a82.27,82.27,0,0,0,7.71,7.91,1.36,1.36,0,0,1-1.64,2.15Zm42.4,20.55a1.32,1.32,0,0,1-.57-1.35,1.35,1.35,0,0,1,1.54-1.12h0a84.56,84.56,0,0,0,11,1.14,1.37,1.37,0,0,1-.1,2.73A86.65,86.65,0,0,1,824.14,715,1.25,1.25,0,0,1,823.59,714.82Zm-60.52-43.63a1.36,1.36,0,0,1-.44-.48,87.31,87.31,0,0,1-4.71-10.38,1.37,1.37,0,0,1,2.55-1A84.29,84.29,0,0,0,765,669.39a1.37,1.37,0,0,1-2,1.77Zm-9.19-27.86a1.43,1.43,0,0,1-.58-.94,88.14,88.14,0,0,1-.89-11.37,1.37,1.37,0,0,1,2.73-.23.89.89,0,0,1,0,.23,82.63,82.63,0,0,0,.86,11,1.36,1.36,0,0,1-1.15,1.55A1.39,1.39,0,0,1,753.88,643.33Zm.83-29.34a1.37,1.37,0,0,1-.57-1.4,87.23,87.23,0,0,1,3-11,1.36,1.36,0,0,1,2.58.89,85.75,85.75,0,0,0-2.92,10.66,1.35,1.35,0,0,1-1.6,1.06A1.33,1.33,0,0,1,754.71,614Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M765.49,586.63a1.36,1.36,0,0,1-.39-1.84c1-1.57,2-3.12,3-4.62a1.38,1.38,0,0,1,1.89-.35h0a1.35,1.35,0,0,1,.35,1.88l0,0c-1,1.45-2,3-3,4.48a1.36,1.36,0,0,1-1.87.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M790.55,585.87a1,1,0,0,0-.27,1.15L795,598.5a54,54,0,0,0-7.7,15.75l-12,3.32a1,1,0,0,0-.74.92l-.91,14.87a1,1,0,0,0,.62,1l11.47,4.75a54,54,0,0,0,5.75,16.59l-6.11,10.82a1,1,0,0,0,.12,1.17l9.87,11.16a1,1,0,0,0,1.16.27L808,674.37a53.73,53.73,0,0,0,15.75,7.69l3.32,12a1,1,0,0,0,.92.75l14.87.91a1,1,0,0,0,1-.63l4.76-11.46a54,54,0,0,0,16.54-5.76L876,684a1,1,0,0,0,1.18-.12L888.34,674a1,1,0,0,0,.26-1.16l-4.74-11.47a54.48,54.48,0,0,0,7.69-15.75l12-3.32a1,1,0,0,0,.74-.93l.91-14.87a1,1,0,0,0-.62-1l-11.47-4.79a54.23,54.23,0,0,0-5.71-16.57l6.11-10.81a1,1,0,0,0-.12-1.18L883.52,581a1,1,0,0,0-1.15-.26l-11.48,4.74a54.38,54.38,0,0,0-15.7-7.66l-3.32-12a1,1,0,0,0-.92-.74l-14.87-.91a1,1,0,0,0-1,.62l-4.75,11.47A54.2,54.2,0,0,0,813.75,582l-10.81-6.12a1,1,0,0,0-1.18.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M830.86,642.55h0a15.28,15.28,0,1,1,11.45,2.4,15.28,15.28,0,0,1-11.45-2.4Zm14.9-21.85a11.18,11.18,0,0,0-12.57,18.46h0a11.18,11.18,0,0,0,12.57-18.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M818.34,661.57a38.08,38.08,0,0,1-15.47-40.87l.24-.89,3.94,1.1a34.42,34.42,0,0,0-1.2,7.12h0a34.38,34.38,0,0,0,.43,7.85h0a34,34,0,0,0,20,25.3,33.29,33.29,0,0,0,8.57,2.43h.53l.61.07c.54.06,1.1.11,1.66.14a33.6,33.6,0,0,0,24.54-8.28A33.9,33.9,0,0,0,824.14,600l-1.95-3.63a38,38,0,1,1-3.87,65.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M1029.57,427.7a1.34,1.34,0,0,1-.63-1.07c-.09-1.77-.21-3.54-.36-5.26a1.33,1.33,0,0,1,2.65-.24c.16,1.76.29,3.57.37,5.37a1.33,1.33,0,0,1-1.27,1.4A1.28,1.28,0,0,1,1029.57,427.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M835.56,542.56c-2.65-1.63-5.28-3.37-7.79-5.17a1.33,1.33,0,0,1,1.55-2.17c2.9,2.08,5.93,4.06,9,5.89h0a1.33,1.33,0,1,1-1.38,2.28Zm17.18,8.78A1.33,1.33,0,0,1,854,549c3.3,1.38,6.7,2.63,10.1,3.73a1.32,1.32,0,0,1,.87,1.65v0a1.33,1.33,0,0,1-1.68.86c-3.47-1.12-6.94-2.41-10.31-3.82Zm27.36,8a1.33,1.33,0,0,1,.93-2.45c3.52.62,7.11,1.1,10.67,1.42a1.34,1.34,0,0,1-.24,2.66c-3.63-.33-7.3-.82-10.9-1.46a1.27,1.27,0,0,1-.46-.13Zm28.45,1.79a1.31,1.31,0,0,1-.64-1.07,1.33,1.33,0,0,1,1.28-1.36c3.57-.18,7.17-.51,10.72-1a1.33,1.33,0,1,1,.36,2.64c-3.62.5-7.3.84-10.94,1a1.26,1.26,0,0,1-.78-.17Zm28.12-4.61a1.33,1.33,0,0,1,.33-2.42c3.44-1,6.88-2.1,10.23-3.36a1.33,1.33,0,1,1,.94,2.49c-3.42,1.29-6.94,2.44-10.44,3.44a1.35,1.35,0,0,1-1.06-.11Zm26.4-10.75a1.33,1.33,0,0,1-.43-1.84,1.3,1.3,0,0,1,.49-.47c3.15-1.71,6.25-3.57,9.23-5.54a1.35,1.35,0,0,1,1.82.54,1.33,1.33,0,0,1-.35,1.69c-3,2-6.21,3.91-9.43,5.65a1.32,1.32,0,0,1-1.33,0Zm23.38-16.32a1.3,1.3,0,0,1-.31-.26,1.34,1.34,0,0,1,.12-1.88c2.69-2.36,5.31-4.87,7.78-7.45a1.34,1.34,0,0,1,1.93,1.85c-2.53,2.63-5.2,5.19-8,7.6a1.3,1.3,0,0,1-1.52.18Zm19.17-21.1-.08-.06a1.33,1.33,0,0,1-.3-1.85h0c1.85-2.56,3.62-5.23,5.26-7.91.22-.36.44-.72.65-1.09A1.34,1.34,0,0,1,1013,497h0a1.32,1.32,0,0,1,.46,1.81h0l-.66,1.11c-1.69,2.74-3.49,5.46-5.38,8.08a1.33,1.33,0,0,1-1.77.41Zm14-24.86a1.33,1.33,0,0,1-.53-1.65c1.39-3.29,2.65-6.69,3.76-10.09a1.33,1.33,0,0,1,2.54.82c-1.13,3.48-2.43,7-3.84,10.3a1.33,1.33,0,0,1-1.74.72h0Zm8.12-27.34a1.32,1.32,0,0,1-.62-1.37c.63-3.53,1.12-7.12,1.45-10.67a1.33,1.33,0,0,1,2.65.25h0c-.33,3.62-.83,7.29-1.48,10.89a1.32,1.32,0,0,1-1.54,1.08h0a1.2,1.2,0,0,1-.49-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M814.19,526.12a1.3,1.3,0,0,1-.23-.18c-1.3-1.25-2.59-2.53-3.81-3.8a1.33,1.33,0,0,1,1.88-1.88l0,0c1.2,1.24,2.45,2.49,3.74,3.72a1.33,1.33,0,0,1-1.62,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M774.63,434.36a1.32,1.32,0,0,1-.64-1.13c0-1.77,0-3.59.09-5.38a1.33,1.33,0,0,1,2.66.1h0c-.06,1.76-.09,3.53-.09,5.27a1.32,1.32,0,0,1-1.3,1.34h0A1.17,1.17,0,0,1,774.63,434.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M776.57,411.7a1.32,1.32,0,0,1-.62-1.37c.62-3.52,1.41-7.08,2.32-10.56a1.33,1.33,0,0,1,2.58.68c-.9,3.41-1.66,6.89-2.27,10.35a1.33,1.33,0,0,1-1.55,1.08A1.3,1.3,0,0,1,776.57,411.7Zm7.85-26.93a1.33,1.33,0,0,1-.53-1.65c1.37-3.32,2.91-6.63,4.56-9.81a1.33,1.33,0,1,1,2.42,1.1l-.06.12c-1.61,3.12-3.11,6.35-4.46,9.61a1.33,1.33,0,0,1-1.74.72h0ZM798,360.19h-.08a1.33,1.33,0,0,1-.32-1.85c2.07-2.94,4.29-5.82,6.61-8.57a1.33,1.33,0,0,1,2,1.72c-2.27,2.69-4.44,5.51-6.47,8.38a1.32,1.32,0,0,1-1.74.36Zm18.61-21a1,1,0,0,1-.29-.24,1.34,1.34,0,0,1,.09-1.88h0c2.67-2.41,5.47-4.74,8.33-6.91a1.33,1.33,0,1,1,1.61,2.12c-2.8,2.13-5.54,4.41-8.15,6.76a1.31,1.31,0,0,1-1.59.2Zm22.75-16.41a1.34,1.34,0,0,1,0-2.3c3.12-1.77,6.36-3.43,9.63-4.93a1.34,1.34,0,0,1,1.77.66,1.33,1.33,0,0,1-.66,1.76c-3.19,1.47-6.37,3.1-9.43,4.83a1.33,1.33,0,0,1-1.31,0Zm25.77-11.07a1.4,1.4,0,0,1-.58-.75,1.33,1.33,0,0,1,.89-1.66h0c3.44-1,7-2,10.47-2.72a1.35,1.35,0,0,1,1.59,1,1.34,1.34,0,0,1-1,1.58c-3.44.73-6.88,1.63-10.25,2.65a1.34,1.34,0,0,1-1.09-.08Zm27.56-5.17a1.34,1.34,0,0,1-.42-1.85,1.36,1.36,0,0,1,1-.62c3.58-.26,7.22-.38,10.81-.35a1.34,1.34,0,0,1,0,2.67c-3.51,0-7.07.08-10.58.34a1.34,1.34,0,0,1-.83-.14Zm28,1a1.34,1.34,0,0,1,.89-2.46c3.54.53,7.12,1.21,10.63,2a1.34,1.34,0,0,1-.61,2.6c-3.44-.81-6.94-1.48-10.41-2a1.25,1.25,0,0,1-.47-.07Zm27.14,7.11a1.34,1.34,0,0,1,1.17-2.39c3.37,1.29,6.71,2.73,9.94,4.29a1.33,1.33,0,0,1-1.16,2.4c-3.16-1.52-6.43-2.94-9.73-4.2Zm33.6,19.14-.13-.1c-2.76-2.18-5.64-4.28-8.57-6.23a1.33,1.33,0,1,1,1.48-2.22h0c3,2,5.93,4.13,8.75,6.37a1.33,1.33,0,1,1-1.53,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M997.93,349.56a1.53,1.53,0,0,1-.31-.26c-1.16-1.33-2.36-2.63-3.56-3.89a1.33,1.33,0,0,1,1.93-1.84h0c1.22,1.28,2.44,2.62,3.63,4a1.33,1.33,0,0,1-1.69,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M984,377.7a1.55,1.55,0,0,0-1.59-.8L964,379.8a81.43,81.43,0,0,0-20.27-16.74l-.65-18.6a1.52,1.52,0,0,0-1.08-1.41l-21.37-6.55a1.52,1.52,0,0,0-1.68.57l-11,15a81.09,81.09,0,0,0-26.13,2.63L868.19,342a1.53,1.53,0,0,0-1.76-.24L846.7,352.21a1.54,1.54,0,0,0-.8,1.59l2.9,18.4a81.61,81.61,0,0,0-16.74,20.27l-18.6.65a1.53,1.53,0,0,0-1.41,1.08l-6.55,21.37a1.52,1.52,0,0,0,.57,1.68l15,11a81.29,81.29,0,0,0,2.51,26.17L810.93,468a1.53,1.53,0,0,0-.24,1.76l10.5,19.69a1.54,1.54,0,0,0,1.59.8l18.4-2.9a81.4,81.4,0,0,0,20.27,16.74l.65,18.6a1.52,1.52,0,0,0,1.08,1.41l21.36,6.56a1.52,1.52,0,0,0,1.68-.57l11-15a80.74,80.74,0,0,0,26.17-2.51L937,525.32a1.52,1.52,0,0,0,1.76.24l19.73-10.48a1.52,1.52,0,0,0,.8-1.59l-2.9-18.4a81.22,81.22,0,0,0,16.74-20.27l18.6-.65a1.52,1.52,0,0,0,1.41-1.08l6.55-21.37a1.52,1.52,0,0,0-.57-1.68l-15-11a81.29,81.29,0,0,0-2.51-26.17l12.7-13.62a1.51,1.51,0,0,0,.24-1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M891.19,452.27a21.86,21.86,0,1,1,10.28,3.16A21.87,21.87,0,0,1,891.19,452.27Zm20.67-33.89a17.74,17.74,0,0,0-8.41-2.58h0a17.83,17.83,0,1,0,12.34,5.84,18.27,18.27,0,0,0-3.91-3.26Zm-8.31-4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M873,481.58a55.92,55.92,0,0,1,45.55-101.17l1.34.43a57.46,57.46,0,0,1,8.65,3.71l1,.53-2,3.49a52.75,52.75,0,0,0-10.17-4.34h-.1a51.9,51.9,0,1,0,35.31,37.23l3.88-1A55.94,55.94,0,0,1,873,481.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1708.41,1256.94l-8.75-626.69c-.1-6.88,5.81-12.5,13.13-12.5h0c11.84,0,21.44-9,21.44-20.14V444.54c0-9.75,8.6-17.56,19-17.23l47.23,1.47c11.62.36,20.91,9.21,21.13,20.13l16.15,808Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1914.75,1372.84a4,4,0,0,0,4-4V896.16a4,4,0,0,0-7.91,0v472.73A4,4,0,0,0,1914.75,1372.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2021.92,1372.84a4,4,0,0,0,4-4V896.16a4,4,0,0,0-7.91,0v472.73A4,4,0,0,0,2021.92,1372.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2285.24,1375.84a3.86,3.86,0,0,0,1.54-.32,4,4,0,0,0,2.09-5.19L2086.63,894.62a4,4,0,0,0-7.27,3.09l202.23,475.72A4,4,0,0,0,2285.24,1375.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2160.31,1375.84a3.78,3.78,0,0,0,1.55-.32,4,4,0,0,0,2.09-5.19L1961.71,894.62a4,4,0,0,0-7.28,3.09l202.24,475.72A4,4,0,0,0,2160.31,1375.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1903.04,
    y: 889.37,
    width: 196.4,
    height: 11.15,
    rx: 2.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1988.63,972.86h125.29a4,4,0,0,0,0-7.91H1988.63a4,4,0,1,0-1.19,7.91A4,4,0,0,0,1988.63,972.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2027.07,
    y: 1054.92,
    width: 125.29,
    height: 7.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2064.29,
    y: 1144.89,
    width: 125.29,
    height: 7.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2103.32,1242.77h125.29a4,4,0,0,0,0-7.91H2103.32a4,4,0,1,0-1.19,7.91A4,4,0,0,0,2103.32,1242.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2141.05,1332.7h125.29a4,4,0,1,0,0-7.91H2141.05a4,4,0,0,0,0,7.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M1370.7,1421.15c-9.34.81-25.55,2.12-38.33,2.68-7.69.34-12.11-.41-14.66-1.43v.81a2.64,2.64,0,0,0,2.51,2.5,447,447,0,0,0,50.19,0,1.88,1.88,0,0,0,1.53-2.83A16.06,16.06,0,0,0,1370.7,1421.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M1332.37,1423.83c12.78-.56,29-1.87,38.33-2.68-9.19-11.26-38.33-18.86-38.33-18.86h-8.24a34.59,34.59,0,0,0-6.42,20.11C1320.26,1423.42,1324.68,1424.17,1332.37,1423.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M1322.75,1388.85l.77,15.25a3.49,3.49,0,0,0,3,3.27,13.35,13.35,0,0,0,6.18-.51,4.1,4.1,0,0,0,2.77-3.17l2.67-14.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M1215.82,1423.7c-4-.57-5.89-2.67-6.66-4.92v.06c-.6,2.37.78,4.83,3.55,6a22.88,22.88,0,0,0,9.82,1.54,9.7,9.7,0,0,0,7.36-3.4h0C1226.86,1424.48,1222.57,1424.7,1215.82,1423.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M1234.91,1388.75h-6.78c-10.35-.21-16.84,21.6-19,30,.77,2.25,2.61,4.35,6.66,4.92,6.75.94,11,.76,14.09-.75,5.58-7.35,8.35-18.12,9.69-24.4A8.57,8.57,0,0,0,1234.91,1388.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M1229,1374.6l-3.77,15a4.08,4.08,0,0,0,2.12,4.61c2.1,1.08,5.07,2.22,7.8,1.89a3.39,3.39,0,0,0,2.78-2.27l5.53-15.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1224.5,1378.94c4.69,4.16,20,4.71,20,4.71,55-131.9,77.43-150.64,77.43-150.64-7.93,49.78-1.28,160-1.28,160,9.07,4,20.77,0,20.77,0a849.45,849.45,0,0,1,28.06-208.62c-37.14-.83-56.9-13.54-63.35-18.65C1275.12,1215.7,1224.5,1378.94,1224.5,1378.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M1315.52,1014.06c-7,35.07-4.51,97.83-2.86,126.46.47,8-5.15,19.2-9.69,26.81a2.41,2.41,0,0,0,.84,3.28l.16.08c7.6,3.91,33.36,16,63.2,17.52a4.24,4.24,0,0,0,4.28-3.18c22.14-82.66,47.86-135.49,47.86-135.49C1390.88,1004.21,1315.52,1014.06,1315.52,1014.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M1325.63,1229.89a1.74,1.74,0,0,1-.91-.26,1.77,1.77,0,0,1-.59-2.42,55.39,55.39,0,0,1,21.79-18.91,1.76,1.76,0,0,1,1.53,3.17,52.71,52.71,0,0,0-20.31,17.57A1.74,1.74,0,0,1,1325.63,1229.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M1271.42,1114.7c2.26,16.34,8.93,34.16,22.28,53.09l5.07-4.14a156.63,156.63,0,0,1-2.53-50.73C1288,1111.31,1278.28,1113,1271.42,1114.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M1323.37,1057.33l-7.85-43.27s-52.47,40.1-44.1,100.64c6.86-1.73,16.59-3.39,24.82-1.78C1298.64,1093.49,1305.81,1072.4,1323.37,1057.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M1419.27,1049.54,1399,1093.16c3.27,26.33,17.42,37.72,32.67,42.09a92.49,92.49,0,0,1,6.8-28.41C1419,1086.7,1419.27,1049.54,1419.27,1049.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M1438.49,1106.84a92.49,92.49,0,0,0-6.8,28.41c40.69,15.78,51.46-14.84,51.46-14.84l-7.52-1.32C1458.64,1120.88,1446.78,1115.4,1438.49,1106.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M1400.61,995.7l-9.78,35.94a7,7,0,0,1-8.6,4.9,7.32,7.32,0,0,1-.75-.25,140.74,140.74,0,0,1-14.09-6.43,9.42,9.42,0,0,1-3.79-12.77,7.68,7.68,0,0,1,.47-.78l20.32-30.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1501.8,1096.36l-250.53,91.19a19.17,19.17,0,0,0-11.49,24.56c.18.49.37,1,.59,1.44l.76,1.67a17.82,17.82,0,0,0,23.61,8.86l.11,0,243.26-112.54Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-270",
    cx: 1616.95,
    cy: 1041.51,
    rx: 123.67,
    ry: 121.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1617,906.38c-76,0-137.61,60.5-137.61,135.13S1541,1176.7,1617,1176.7s137.61-60.5,137.61-135.14S1693,906.38,1617,906.38Zm0,250.42c-64.84,0-117.4-51.62-117.4-115.29s52.56-115.28,117.4-115.28,117.4,51.62,117.4,115.28S1681.79,1156.8,1617,1156.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1489,1057.43c-.4-3.19-.69-6.45-.85-9.68a.77.77,0,0,1,1.54-.08c.16,3.19.44,6.41.85,9.56a.78.78,0,0,1-.67.87h-.1A.78.78,0,0,1,1489,1057.43Zm1.58-37.13a.77.77,0,0,1-.63-.89h0A123.93,123.93,0,0,1,1497.4,994h0C1517.21,946,1564.14,914.9,1617,914.9a130.29,130.29,0,0,1,69.24,19.8.78.78,0,0,1,.24,1.07.75.75,0,0,1-1,.25h0A128.74,128.74,0,0,0,1617,916.46c-52.18,0-98.54,30.69-118.12,78.17h0a122.26,122.26,0,0,0-7.33,25.06.76.76,0,0,1-.76.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M1422,968.39c.09.62-8.16,41-8.16,41l-23-5.2,2.12-39.45S1420.51,958.06,1422,968.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1398.19,973.55l-2.75,20.68a3.48,3.48,0,0,0,0,.79c.23,1.62,1.43,7.14,7,5.56,5.06-1.43,9.69-2.66,12.89-1.68a2.91,2.91,0,0,1,2,3.37,125.18,125.18,0,0,1-5.29,18.82,2.9,2.9,0,0,1-3.53,1.72c-4.35-1.27-13.46-4.21-20.24-8.29a2.91,2.91,0,0,1-1.42-2.62c.22-5.22.83-21.09.32-25.54-.49-4.17-5.61-6.67-7.84-7.57a2.84,2.84,0,0,1-1.59-1.6c-1-2.58-2.45-8.56,5.08-11a2.9,2.9,0,0,0,1.89-3.65.56.56,0,0,0,0-.12c-1.12-3.11-1.59-7.85,4.24-10.46s10.35.5,12.74,3.07a2.91,2.91,0,0,0,3.71.43,2.32,2.32,0,0,1,2.63.09,2.86,2.86,0,0,0,3.93-1,2,2,0,0,0,.13-.25c1.42-2.91,4.31-6,10.11-5,10.29,1.77,11.46,13.17,8.74,19.85s-13.76,4.14-19.3.77c-4.22-2.56-9.69.13-12.06,1.56A2.89,2.89,0,0,0,1398.19,973.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M1386.24,993.9s4.23-11.84-.11-14.75-10.79-1.39-9.37,7.19C1378.52,997,1386.24,993.9,1386.24,993.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M1296.68,1162.93l23.68-1.93,10.26,9.46s-2.43,3.35-10,1.42-18-2.4-18-2.4-10.48,4.72-10.6-4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M1480.13,1126c2,1.6,9.07-1.74,13.36-4a5,5,0,0,0,2.39-5.84c-1-3.26-2.76-7.47-4.88-8C1487.48,1107.25,1471.69,1119.42,1480.13,1126Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1256.19,1220.33a.77.77,0,0,0,.25-1.5c-7.13-2.47-10.87-6.47-11.1-11.89a13.2,13.2,0,0,1,8.64-12.71l30.08-11.73a.76.76,0,0,0,.44-1,.77.77,0,0,0-1-.44l-30.08,11.73a14.75,14.75,0,0,0-9.63,14.21c.27,6.12,4.36,10.59,12.15,13.29A.73.73,0,0,0,1256.19,1220.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1293.07,1178.94a.66.66,0,0,0,.28,0l3.9-1.52a.77.77,0,0,0-.54-1.45h0l-3.89,1.52a.77.77,0,0,0-.45,1v0A.77.77,0,0,0,1293.07,1178.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M377.45,688.45l-11.19,11c-15.89-1.53-28.13-6.47-37.53-12.74,5.66-14.07,11.41-22.41,15.92-27.3C359.44,680.24,377.45,688.45,377.45,688.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M299.57,647.17,326,605.88c1.73,23.29,9.6,40.8,18.68,53.57-4.51,4.89-10.26,13.23-15.92,27.3A72.55,72.55,0,0,1,299.57,647.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M271.48,973.46c13.17.61,25.91.23,34.42-.21-7.75-5.51-25.59-17.51-40.53-22.28l-10.25-.62s-3.47,5.29-4.71,17.38C252.11,969.85,257.07,972.8,271.48,973.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M306,973.33l-.11-.08c-8.51.44-21.25.82-34.42.21-14.41-.66-19.37-3.61-21.07-5.73-.06.55-.12,1.11-.17,1.69a4.8,4.8,0,0,0,4.39,5.18h0c10.78.82,37.51,2.67,50.4,2a1.8,1.8,0,0,0,1.71-1.88A1.76,1.76,0,0,0,306,973.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M177.32,969.94c-1-6.18-2.51-15.11-3.7-17.4-1.87-3.58-8.29,0-8.29,0s-4.5,2.1-6.57,5.6c-1.33,2.23-5,8.58-7.46,12.89a2.87,2.87,0,0,0-.38,1.54l25.68.89A5,5,0,0,0,177.32,969.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M150.92,972.57a2.92,2.92,0,0,0,2.84,2.84l18.3.5a5.1,5.1,0,0,0,4.54-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M179.29,932c-.22.74-3.54,16.83-5,23.89a4,4,0,0,1-4.15,3.23c-1.08-.06-2.35-.16-3.67-.33a4.85,4.85,0,0,1-4.24-4.64c-.23-6.18-.35-18.06,1.92-22.66C167.28,925.14,179.29,932,179.29,932Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M253.1,936.61c1.43,0-.56,7.35,1.59,14.62a3.72,3.72,0,0,0,3.42,2.94c1.11,0,2.42,0,3.76-.11a4.14,4.14,0,0,0,3.8-3.72l1.75-18.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M292.92,736.19c-.63,3.1-23.06,133.91-24.42,201.6a2.3,2.3,0,0,1-2,2.24,44.78,44.78,0,0,1-13.77-.09,1.62,1.62,0,0,1-1.34-1.49c-.78-12.61-7.08-119.26.64-169.47,0,0-63.77,134.21-73.44,171.21a1.93,1.93,0,0,1-2,1.46,48.11,48.11,0,0,1-12.92-2.29,3.38,3.38,0,0,1-2.13-4c5.4-22.15,43.25-174.73,69-208.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M252.05,769.82a.84.84,0,0,1-.6-1.42l8.54-8.7a.85.85,0,0,1,1.18,0,.84.84,0,0,1,0,1.18h0l-8.54,8.74A.82.82,0,0,1,252.05,769.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M329.37,572.42c-16.38-4.29-46.59-11-70.64-9.58a10.9,10.9,0,0,0-10.27,10.23c-3.63,64-8.59,120.9-17.94,154,21,8.32,41.85,12.17,62.4,9.15q23.1-49.47,40.37-114.3c17.27-64.83,6.75-34.49.19-46A6.78,6.78,0,0,0,329.37,572.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M290,527.55s-4.14,24.67-5.37,36.08A4.47,4.47,0,0,0,287,568.1c4.52,2.32,14.17,6.07,24.68,2.63a4.16,4.16,0,0,0,2.83-4.06l-.72-33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M317,500.21s8,18.33,8.52,28,2.61,15.87-8.52,17.8-20.5-3.6-25.57-13.18c0,0-8-14.77-6.17-20.82S317,500.21,317,500.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M295.19,525.88h1.4s-5.79-11.88-.7-14,25.3-6.18,29.6-13.33c4.2-6.9.46-15.81-5.14-18.3a.74.74,0,0,0-1,.34h0l-.47.87a.75.75,0,0,1-1,.33.81.81,0,0,1-.38-.47h0a.74.74,0,0,0-.92-.52.76.76,0,0,0-.43.31c-1.34,2.14-4.94,5.62-14.62,7.41-13.73,2.53-22.8,8.09-23,17.58a.76.76,0,0,1-.78.74.69.69,0,0,1-.39-.12c-1-.62-2.64-.91-4.81.91-3.77,3.17-2.22,11.39,6,18.15a.77.77,0,0,1,.16,1.07,1.14,1.14,0,0,1-.16.15c-1.49,1-3.73,3.29,2.06,6.38s9.42,2.82,10.74,2.49a.77.77,0,0,0,.58-.79l-.52-8.4a.76.76,0,0,1,.69-.81h3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M295.52,527.64s-3-11.71-8.29-8.42,2.72,13.12,6.94,13.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M125.19,718.17l-10.77,2.72c-18.5,4.68-30.94,18.57-27.78,31l3.74,14.83c3.16,12.47,20.7,18.79,39.2,14.11l10.78-2.72c.71-.18,1.42-.38,2.13-.59l316-94.56-8.16-32.26-323,67C126.6,717.82,125.88,718,125.19,718.17ZM129.84,733c13.92-3.52,26.9.34,29,8.61s-7.5,17.84-21.42,21.36-26.91-.34-29-8.61,7.46-17.84,21.39-21.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M555.41,606.82l-62.54,15.8a14.87,14.87,0,0,0-10,8.47l-9.31,21.61A14.78,14.78,0,0,0,478,670.21l18.5,14.56a14.77,14.77,0,0,0,12.79,2.72L571.8,671.7c9.44-2.39,17.45,7.46,13,16.11a85.14,85.14,0,0,1-55.09,43.35c-45,11.37-84.77-15.88-95.71-59.14s11.19-86.16,56.11-97.52a85.16,85.16,0,0,1,69.07,12C567.19,592,564.84,604.43,555.41,606.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M556.9,612.7l-62.54,15.81a14.84,14.84,0,0,0-10,8.47L475,658.58a14.81,14.81,0,0,0,4.42,17.52L498,690.7a14.81,14.81,0,0,0,12.79,2.72l62.53-15.81c9.44-2.38,17.45,7.46,13,16.11A85.12,85.12,0,0,1,531.19,737c-45,11.37-84.77-15.88-95.71-59.13s11.14-86.15,56.11-97.52a85.16,85.16,0,0,1,69.07,12C568.7,597.86,566.33,610.33,556.9,612.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.35,722.87l-10.77,2.72c-18.5,4.68-30.94,18.58-27.78,31l3.74,14.82c3.15,12.47,20.7,18.79,39.2,14.12l10.77-2.73c.72-.18,1.43-.37,2.13-.59l316-94.56-8.16-32.3-323,67C127.78,722.52,127.07,722.7,126.35,722.87ZM131,737.7c13.93-3.51,26.91.34,29,8.61s-7.5,17.84-21.42,21.36-26.91-.34-29-8.61S117.07,741.18,131,737.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M206.08,657.7c-8.1,22.73-3.54,47.1-3.54,47.1l-10.68,2.9s-13.79-16.4-10.63-52.81C191.08,653.36,200.31,655.7,206.08,657.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M181.19,654.86c.35-4.09.91-8.43,1.74-13,7.21-40.15,58.68-71,70.8-77.8a1.67,1.67,0,0,1,2.25.64,1.77,1.77,0,0,1,.2.87l-1.72,54.58C225.79,624,212.23,640.41,206,657.76,200.31,655.7,191.08,653.36,181.19,654.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M400,708.48a7,7,0,0,0,4.47-3.87c1.64-3.68,3.49-9.56-.46-11.35-5.87-2.67-16.55,8.27-16.55,8.27L382.19,710l-4.77,2.32C381.82,713.51,390.24,711.51,400,708.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M201.83,699.49H215s-10.71,6.42-11.07,13.17,4.26,20.75,6.41,24.56c2.36,4.16-29.89-6.21-18.51-37.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M1866.63,562.56l.16,4.93c15.16,21.11,29,15.72,38.45,9.39-5.72-14.22-6.73-15.79-11.29-20.73C1876.8,568.62,1866.63,562.56,1866.63,562.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M1935.72,539.4,1909,497.7c-1.75,23.53-5.92,45.57-15.09,58.47,4.56,4.94,5.57,6.51,11.29,20.73C1928.94,561.07,1935.72,539.4,1935.72,539.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M1961.92,889.48c-13.3.62-26.18.23-34.78-.21,7.83-5.57,25.86-17.69,41-22.52l10.36-.62s3.51,5.34,4.77,17.56C1981.5,885.83,1976.48,888.81,1961.92,889.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M1927,889.35l.1-.08c8.6.44,21.48.83,34.78.21,14.56-.67,19.58-3.65,21.3-5.79,0,.56.11,1.12.16,1.71a4.85,4.85,0,0,1-4.43,5.24h0c-10.89.82-37.9,2.69-50.93,2a1.81,1.81,0,0,1-1-3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M2057.06,885.92c1-6.24,2.54-15.27,3.75-17.58,1.89-3.62,8.37,0,8.37,0s4.55,2.13,6.65,5.66c1.33,2.26,5,8.67,7.53,13a3,3,0,0,1,.39,1.55l-26,.9A5.26,5.26,0,0,1,2057.06,885.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M2083.75,888.58a3,3,0,0,1-2.88,2.87l-18.49.51a5.22,5.22,0,0,1-4.59-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M2055.08,847.59c.22.75,3.58,17,5.05,24.14a4.06,4.06,0,0,0,4.19,3.26c1.1-.06,2.38-.16,3.72-.33a4.91,4.91,0,0,0,4.27-4.69c.24-6.25.36-18.25-1.94-22.9C2067.19,840.7,2055.08,847.59,2055.08,847.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M1980.49,852.24c-1.44,0,.57,7.43-1.6,14.77a3.75,3.75,0,0,1-3.46,3c-1.12,0-2.45,0-3.79-.11a4.15,4.15,0,0,1-3.84-3.76l-1.77-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1940.26,649.7c.64,3.13,23.3,135.31,24.67,203.71a2.34,2.34,0,0,0,2,2.26,45.68,45.68,0,0,0,13.91-.09,1.64,1.64,0,0,0,1.35-1.5c.79-12.75,7.16-120.52-.64-171.25,0,0,64.44,135.61,74.2,173a2,2,0,0,0,2,1.47,48.37,48.37,0,0,0,13.06-2.32,3.41,3.41,0,0,0,2.15-4c-5.46-22.38-43.7-176.56-69.67-210.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1981.56,683.7a.82.82,0,0,0,.59-.24.85.85,0,0,0,0-1.2l-8.63-8.82a.83.83,0,0,0-1.19.12.84.84,0,0,0,0,1.06l8.63,8.82A.82.82,0,0,0,1981.56,683.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M1903.42,484.25c16.55-4.34,47.09-11.2,71.39-9.68,7.94.5,9.44,8,9.75,13.55,3.68,64.73,9.31,118.94,18.76,152.36-21.24,8.41-42.29,12.31-63.06,9.25q-23.34-50-40.79-115.5c-17.45-65.5-6.82-34.85-.2-46.47A6.86,6.86,0,0,1,1903.42,484.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M1943.19,438.9s4.18,24.94,5.43,36.47a4.54,4.54,0,0,1-2.45,4.51c-4.57,2.35-14.32,6.14-25,2.66a4.22,4.22,0,0,1-2.86-4.11l.73-33.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1842.74,307.45a1.24,1.24,0,0,0,.47-1.68l-1.7-3-.13.07-10-16.19a1.22,1.22,0,0,0-1.69-.4h0l-1.89,1.16a1.22,1.22,0,0,0-.4,1.69h0l9.22,15a1.23,1.23,0,0,1-.41,1.69l0,0-72.44,40.85a1.23,1.23,0,0,0-.46,1.68h0l1.69,3h0l23.54,41.74a1.23,1.23,0,0,0,1.67.47l1.94-1.09a1.24,1.24,0,0,0,.47-1.68l-22.94-40.67a1.24,1.24,0,0,1,.47-1.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-302",
    x: 1661.52,
    y: 291.22,
    width: 172.36,
    height: 39.2,
    transform: "translate(72.7 898.57) rotate(-29.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1943.33,683l-9.49,4.8a1.49,1.49,0,0,1-2-.66L1782,391.13a1.49,1.49,0,0,1,.66-2l9.48-4.81a1.52,1.52,0,0,1,2,.66L1944,681a1.49,1.49,0,0,1-.64,2Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-303",
    cx: 1672.58,
    cy: 353.01,
    rx: 7.33,
    ry: 19.75,
    transform: "translate(42.29 867.11) rotate(-29.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M1828.11,265.48c5.36,9.5,6.84,18.81,3.32,20.8s-10.72-4.11-16.08-13.6-6.84-18.82-3.32-20.8S1822.75,256,1828.11,265.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M1864.19,563.32a6.39,6.39,0,0,1-.75-5.38c1.09-3.53,3.37-8.71,7.18-7.57,5.68,1.71,6.44,15.73,6.44,15.73l-1.51,9,1.89,4.49C1873.7,577.77,1869.09,571.29,1864.19,563.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M1995.55,595c2.32-3.25,4.64-6.81,6.94-10.74,22.7-38.88-18.94-98.43-18.94-98.43l-12.69,37.78c18.76,20.92,10.88,41.1,4.5,57.85C1967,603.38,1930.87,622,1930.87,622l6.88,8.5S1974.9,623.93,1995.55,595Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M2009.82,545.19c-.47-30.19-24.45-62.26-28.83-67.9a.67.67,0,0,0-.94-.11.62.62,0,0,0-.2.25l-9,46.17c3.82,8.92,3,14.53,6.85,22.57,10.32-1.45,19.89-1.52,30.06.68a1.68,1.68,0,0,0,2-1.25A1.9,1.9,0,0,0,2009.82,545.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M1930.87,622c-2.12-1.06-18.66,1.34-16.12,3.62,4.45,4,4.64,7,0,10.74-2.31,1.85-7.62,4.64-9.06.34-.41-1.21-.47-2.78-1.62-3.33-.85-.41-3.25,2.51-3.4,3.44-.8,5.24,3.38,9.59,8,11.33a34.23,34.23,0,0,0,7,1.56,38.33,38.33,0,0,0,4.89.56,2.59,2.59,0,0,0,.8-.78c1.07-1.19,6.84-6,8.1-7.68.68-.88,9.32-11.77,8.88-12.82C1938.28,629,1932.65,622.88,1930.87,622Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M1914.3,412.34s-13.37,25.16-11.66,35.32,18.28,9.43,32.74,1.18l10.11-27.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1934.74,435.5a1,1,0,0,1-.45-1.52,26.8,26.8,0,0,0,3.72-7.89s2.4-1.54-6.11-3.58-21.22-5.2-23.89-12.45c-2.61-7.07,4.23-24.85,15.14-10.68a1,1,0,0,0,1.39.26,1.07,1.07,0,0,0,.26-.26c1.79-2.33,6.49-7.16,13-4.23,6.11,2.74,6.79,7.22,6.71,9.47a1,1,0,0,0,.91,1.08.8.8,0,0,0,.31,0c3.09-.59,10.5-1.1,14,6.51,2.85,6.26,1,9.81-.69,11.54a1,1,0,0,0-.07,1.41.91.91,0,0,0,.52.31c2,.62,4.65,2.34,4.39,7.1-.37,6.57-7.72,6-9.81,5.69a1,1,0,0,0-.92.33c-1.8,2-9.88,10.42-18.63,11.44a1,1,0,0,1-1.15-.93,1,1,0,0,1,.05-.46l3.79-11a1,1,0,0,0-.57-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M1933.19,437.06s9.52-6.53,10.21-1-8.57,8-13.15,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1981.76,1394.3c-36.23,12.1-71.42,12.11-105.36,1a20.86,20.86,0,0,1-14.4-19.82V1209.3c41.71,9.18,85.43,9.64,131.49,0v168.81A17.09,17.09,0,0,1,1981.76,1394.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1927.75,
    cy: 1207.97,
    rx: 65.74,
    ry: 13.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M1993.49,1337.3q-65.74,22.86-131.49,0V1271c44.23,10.91,88.07,11.46,131.49,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M1869.06,1224.41a11,11,0,0,0,12.7,7.51c3.71-.92,6.88-3.82,10.7-3.88,4.34-.08,7.8,3.5,10.33,7a69.76,69.76,0,0,1,10.28,21.17c.74,2.52,1.38,5.19,3.15,7.13,3.79,4.15,11,2.82,15.17-.9s6.5-9.08,9.63-13.75,7.93-9,13.54-8.68c1.88.12,3.69.76,5.57.84a9.66,9.66,0,0,0,9.4-6.78,16.16,16.16,0,0,1,1.1-3.65c1.9-3.33,6.92-3.65,9.52-6.34,1.65-1.71,2.2-4.2,4.12-5.88.73-.63,5.71-2.69,5.82-3,.87-2.68-1.91-5.1-4.49-6.25-15.11-6.73-32.39,0-48.78,2.28-16.09,2.25-31.5-1.42-47.44-1.28C1880.58,1210,1865.78,1212.15,1869.06,1224.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-313",
    cx: 1928.51,
    cy: 1208.35,
    rx: 65.74,
    ry: 13.21
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 1926.76,
    cy: 1208.35,
    rx: 54.12,
    ry: 7.99
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectmanagement1);
export default __webpack_public_path__ + "static/media/projectmanagement_1.ac94d38ebbe5b9581380700702cefbf4.svg";
export { ForwardRef as ReactComponent };